// List of countries for avoid countries feature

const countries = [
  {
    'en-gb': 'Afghanistan',
    official_en_name: 'Islamic Republic of Afghanistan',
    cid: '1',
    native_names: 'Owganystan, Afghanistan, Ø§ÙØºØ§Ù†Ø³ØªØ§Ù†',
    'ru-ru': 'ÐÑ„Ð³Ð°Ð½Ð¸ÑÑ‚Ð°Ð½',
    'en-us': 'Afghanistan',
    id: 0,
    'zh-cn': 'é˜¿å¯Œæ±—',
    'de-de': 'Afghanistan',
    'fr-fr': 'Afghanistan',
    country_code: 'AFG',
    'es-es': 'AfganistÃ¡n',
    'pt-br': 'Afeganistão'
  }, {
    'en-gb': 'Albania',
    official_en_name: 'Republic of Albania',
    cid: '2',
    native_names: 'shqipÃ«ria, Albania',
    'ru-ru': 'ÐÐ»Ð±Ð°Ð½Ð¸Ñ',
    'en-us': 'Albania',
    id: 1,
    'zh-cn': 'é˜¿å°”å·´å°¼äºš',
    'de-de': 'Albanien',
    'fr-fr': 'Albanie',
    country_code: 'ALB',
    'es-es': 'Albania',
    'pt-br': 'Albânia'
  }, {
    'en-gb': 'Algeria',
    official_en_name: 'People`s Democratic Republic of Algeria',
    cid: '3',
    native_names: 'Ø§Ù„Ø¬Ø²Ø§Ø¦Ø±, Algeria',
    'ru-ru': 'ÐÐ»Ð¶Ð¸Ñ€',
    'en-us': 'Algeria',
    id: 2,
    'zh-cn': 'é˜¿å°”åŠåˆ©äºš',
    'de-de': 'Algerien',
    'fr-fr': 'AlgÃ©rie',
    country_code: 'DZA',
    'es-es': 'Argelia',
    'pt-br': 'Argélia'
  }, {
    'en-gb': 'Andorra',
    official_en_name: 'Principality of Andorra',
    cid: '4',
    native_names: 'Andorra',
    'ru-ru': 'ÐÐ½Ð´Ð¾Ñ€Ñ€Ð°',
    'en-us': 'Andorra',
    id: 3,
    'zh-cn': 'å®‰é“å°”',
    'de-de': 'Andorra',
    'fr-fr': 'Andorre',
    country_code: 'AND',
    'es-es': 'Andorra',
    'pt-br': 'Andorra'
  }, {
    'en-gb': 'Angola',
    official_en_name: 'Republic of Angola',
    cid: '5',
    native_names: 'Angola',
    'ru-ru': 'ÐÐ½Ð³Ð¾Ð»Ð°',
    'en-us': 'Angola',
    id: 4,
    'zh-cn': 'å®‰å“¥æ‹‰',
    'de-de': 'Angola',
    'fr-fr': 'Angola',
    country_code: 'AGO',
    'es-es': 'Angola',
    'pt-br': 'Angola'
  }, {
    'en-gb': 'Anguilla',
    official_en_name: 'Anguilla',
    'zh-cn': 'å®‰åœ­æ‹‰',
    native_names: 'Anguilla',
    'ru-ru': 'ÐÐ½Ð³Ð¸Ð»ÑŒÑ',
    'en-us': 'Anguilla',
    'pt-br': 'Anguilla',
    'de-de': 'Anguilla',
    cid: '6',
    'fr-fr': 'Anguilla',
    country_code: 'AIA',
    'es-es': 'Anguilla',
    id: 5
  }, {
    'en-gb': 'Antigua and Barbuda',
    official_en_name: 'Antigua and Barbuda',
    cid: '7',
    native_names: 'Antigua and Barbuda',
    'ru-ru': 'ÐÐ½Ñ‚Ð¸Ð³ÑƒÐ° Ð¸ Ð‘Ð°Ñ€Ð±ÑƒÐ´Ð°',
    'en-us': 'Antigua and Barbuda',
    id: 6,
    'zh-cn': 'å®‰æç“œå’Œå·´å¸ƒè¾¾',
    'de-de': 'Antigua und Barbuda',
    'fr-fr': 'Antigua-et-Barbuda',
    country_code: 'ATG',
    'es-es': 'Antigua y Barbuda',
    'pt-br': 'Antígua e Barbuda'
  }, {
    'en-gb': 'Argentina',
    official_en_name: 'Argentine Republic',
    cid: '8',
    native_names: 'Argentina',
    'ru-ru': 'ÐÑ€Ð³ÐµÐ½Ñ‚Ð¸Ð½Ð°',
    'en-us': 'Argentina',
    id: 7,
    'zh-cn': 'é˜¿æ ¹å»·',
    'de-de': 'Argentinien',
    'fr-fr': 'Argentine',
    country_code: 'ARG',
    'es-es': 'Argentina',
    'pt-br': 'Argentina'
  }, {
    'en-gb': 'Armenia',
    official_en_name: 'Republic of Armenia',
    cid: '9',
    native_names: 'Õ€Õ¡ÕµÕ¡Õ½Õ¿Õ¡Õ¶, Armenia',
    'ru-ru': 'ÐÑ€Ð¼ÐµÐ½Ð¸Ñ',
    'en-us': 'Armenia',
    id: 8,
    'zh-cn': '`Äºšç¾Žå°¼äºš',
    'de-de': 'Armenien',
    'fr-fr': 'ArmÃ©nie',
    country_code: 'ARM',
    'es-es': 'Armenia',
    'pt-br': 'Armênia'
  }, {
    'en-gb': 'Australia',
    official_en_name: 'Commonwealth of Australia',
    cid: '10',
    native_names: 'Australia',
    'ru-ru': 'ÐÐ²ÑÑ‚Ñ€Ð°Ð»Ð¸Ñ',
    'en-us': 'Australia',
    id: 9,
    'zh-cn': 'æ¾³å¤§åˆ©äºš',
    'de-de': 'Australien',
    'fr-fr': 'Australie',
    country_code: 'AUS',
    'es-es': 'Australia',
    'pt-br': 'AustrÃ¡lia'
  }, {
    'en-gb': 'Austria',
    official_en_name: 'Republic of Austria',
    cid: '11',
    native_names: 'Ã–sterreich, Austria',
    'ru-ru': 'ÐÐ²ÑÑ‚Ñ€Ð¸Ñ',
    'en-us': 'Austria',
    id: 10,
    'zh-cn': 'å¥¥åœ°åˆ©',
    'de-de': 'Ã–sterreich',
    'fr-fr': 'Autriche',
    country_code: 'AUT',
    'es-es': 'Austria',
    'pt-br': 'Áustria'
  }, {
    'en-gb': 'Azerbaijan',
    official_en_name: 'Republic of Azerbaijan',
    cid: '12',
    native_names: 'ÐÐ·ÐµÑ€Ð±Ð°Ð¹Ð´Ð¶Ð°Ð½, Azerbaijan, AzÉ™rbaycan',
    'ru-ru': 'ÐÐ·ÐµÑ€Ð±Ð°Ð¹Ð´Ð¶Ð°Ð½',
    'en-us': 'Azerbaijan',
    id: 11,
    'zh-cn': 'é˜¿å¡žæ‹œç–†',
    'de-de': 'Aserbaidschan',
    'fr-fr': 'AzerbaÃ¯djan',
    country_code: 'AZE',
    'es-es': 'AzerbaiyÃ¡n',
    'pt-br': 'Azerbaijão'
  }, {
    'en-gb': 'Bahrain',
    official_en_name: 'Kingdom of Bahrain',
    cid: '13',
    native_names: 'â€Ø§Ù„Ø¨Ø­Ø±ÙŠÙ†, Bahrain',
    'ru-ru': 'Ð‘Ð°Ñ…Ñ€ÐµÐ¹Ð½',
    'en-us': 'Bahrain',
    id: 12,
    'zh-cn': 'å·´æž—',
    'de-de': 'Bahrain',
    'fr-fr': 'BahreÃ¯n',
    country_code: 'BHR',
    'es-es': 'Bahrein',
    'pt-br': 'Bahrein'
  }, {
    'en-gb': 'Bangladesh',
    official_en_name: 'People`s Republic of Bangladesh',
    cid: '14',
    native_names: 'à¦¬à¦¾à¦‚à¦²à¦¾à¦¦à§‡à¦¶, Bangladesh',
    'ru-ru': 'Ð‘Ð°Ð½Ð³Ð»Ð°Ð´ÐµÑˆ',
    'en-us': 'Bangladesh',
    id: 13,
    'zh-cn': 'å­ŸåŠ æ‹‰å›½',
    'de-de': 'Bangladesch',
    'fr-fr': 'Bangladesh',
    country_code: 'BGD',
    'es-es': 'Bangladesh',
    'pt-br': 'Bangladesh'
  }, {
    'en-gb': 'Barbados',
    official_en_name: 'Barbados',
    cid: '15',
    native_names: 'Barbados',
    'ru-ru': 'Ð‘Ð°Ñ€Ð±Ð°Ð´Ð¾Ñ',
    'en-us': 'Barbados',
    id: 14,
    'zh-cn': 'å·´å·´å¤šæ–¯',
    'de-de': 'Barbados',
    'fr-fr': 'Barbade',
    country_code: 'BRB',
    'es-es': 'Barbados',
    'pt-br': 'Barbados'
  }, {
    'en-gb': 'Belarus',
    official_en_name: 'Republic of Belarus',
    cid: '16',
    native_names: 'Ð‘ÐµÐ»Ð°Ñ€ÑƒÑÑŒ, Belarus, Ð‘ÐµÐ»Ð°Ñ€ÑƒÌÑÑŒ',
    'ru-ru': 'Ð‘ÐµÐ»Ð°Ñ€ÑƒÑÑŒ',
    'en-us': 'Belarus',
    id: 15,
    'zh-cn': 'ç™½ä¿„ç½—æ–¯',
    'de-de': 'WeiÃŸrussland',
    'fr-fr': 'BiÃ©lorussie',
    country_code: 'BLR',
    'es-es': 'Bielorrusia',
    'pt-br': 'Bielorrússia'
  }, {
    'en-gb': 'Belgium',
    official_en_name: 'Kingdom of Belgium',
    cid: '17',
    native_names: 'Belgique, Belgium, Belgien, BelgiÃ«',
    'ru-ru': 'Ð‘ÐµÐ»ÑŒÐ³Ð¸Ñ',
    'en-us': 'Belgium',
    id: 16,
    'zh-cn': 'æ¯”åˆ©æ—¶',
    'de-de': 'Belgien',
    'fr-fr': 'Belgique',
    country_code: 'BEL',
    'es-es': 'BÃ©lgica',
    'pt-br': 'Bélgica'
  }, {
    'en-gb': 'Belize',
    official_en_name: 'Belize',
    cid: '18',
    native_names: 'Belice, Belize',
    'ru-ru': 'Ð‘ÐµÐ»Ð¸Ð·',
    'en-us': 'Belize',
    id: 17,
    'zh-cn': '`Ä¼¯åˆ©å…¹',
    'de-de': 'Belize',
    'fr-fr': 'Belize',
    country_code: 'BLZ',
    'es-es': 'Belice',
    'pt-br': 'Belize'
  }, {
    'en-gb': 'Benin',
    official_en_name: 'Republic of Benin',
    cid: '19',
    native_names: 'BÃ©nin, Benin',
    'ru-ru': 'Ð‘ÐµÐ½Ð¸Ð½',
    'en-us': 'Benin',
    id: 18,
    'zh-cn': 'è´å®',
    'de-de': 'Benin',
    'fr-fr': 'BÃ©nin',
    country_code: 'BEN',
    'es-es': 'BenÃ­n',
    'pt-br': 'Benin'
  }, {
    'en-gb': 'Bermuda',
    official_en_name: 'Bermuda',
    cid: '20',
    native_names: 'Bermuda',
    'ru-ru': 'Ð‘ÐµÑ€Ð¼ÑƒÐ´ÑÐºÐ¸Ðµ ÐžÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'Bermuda',
    id: 19,
    'zh-cn': 'ç™¾æ…•å¤§',
    'de-de': 'Bermuda',
    'fr-fr': 'Bermudes',
    country_code: 'BMU',
    'es-es': 'Bermudas',
    'pt-br': 'Bermudas'
  }, {
    'en-gb': 'Bhutan',
    official_en_name: 'Kingdom of Bhutan',
    cid: '21',
    native_names: 'à½ à½–à¾²à½´à½‚à¼‹à½¡à½´à½£à¼‹, Bhutan',
    'ru-ru': 'Ð‘ÑƒÑ‚Ð°Ð½',
    'en-us': 'Bhutan',
    id: 20,
    'zh-cn': '`Ä¸ä¸¹',
    'de-de': 'Bhutan',
    'fr-fr': 'Bhoutan',
    country_code: 'BTN',
    'es-es': 'ButÃ¡n',
    'pt-br': 'Butão'
  }, {
    'en-gb': 'Bolivia',
    official_en_name: 'Plurinational State of Bolivia',
    cid: '22',
    native_names: 'Wuliwya, Bolivia, VolÃ­via, Buliwya',
    'ru-ru': 'Ð‘Ð¾Ð»Ð¸Ð²Ð¸Ñ',
    'en-us': 'Bolivia',
    id: 21,
    'zh-cn': 'çŽ»åˆ©ç»´äºš',
    'de-de': 'Bolivien',
    'fr-fr': 'Bolivie',
    country_code: 'BOL',
    'es-es': 'Bolivia',
    'pt-br': 'Bolívia'
  }, {
    'en-gb': 'Bosnia and Herzegovina',
    official_en_name: 'Bosnia and Herzegovina',
    cid: '23',
    native_names: 'Bosna i Hercegovina, Bosnia and Herzegovina, Ð‘Ð¾ÑÐ½a Ð¸ Ð¥ÐµÑ€Ñ†ÐµÐ³Ð¾Ð²Ð¸Ð½Ð°',
    'ru-ru': 'Ð‘Ð¾ÑÐ½Ð¸Ñ Ð¸ Ð“ÐµÑ€Ñ†ÐµÐ³Ð¾Ð²Ð¸Ð½Ð°',
    'en-us': 'Bosnia and Herzegovina',
    id: 22,
    'zh-cn': 'æ³¢æ–¯å°¼äºšå’Œé»‘å¡žå“¥ç»´é‚£',
    'de-de': 'Bosnien und Herzegowina',
    'fr-fr': 'Bosnie-HerzÃ©govine',
    country_code: 'BIH',
    'es-es': 'Bosnia y Herzegovina',
    'pt-br': 'Bósnia e Herzegovina'
  }, {
    'en-gb': 'Botswana',
    official_en_name: 'Republic of Botswana',
    'zh-cn': 'åšèŒ¨ç“¦çº³',
    native_names: 'Botswana',
    'ru-ru': 'Ð‘Ð¾Ñ‚ÑÐ²Ð°Ð½Ð°',
    'en-us': 'Botswana',
    'pt-br': 'Botswana',
    'de-de': 'Botswana',
    cid: '24',
    'fr-fr': 'Botswana',
    country_code: 'BWA',
    'es-es': 'Botswana',
    id: 23
  }, {
    'en-gb': 'Brazil',
    official_en_name: 'Federative Republic of Brazil',
    cid: '25',
    native_names: 'Brasil, Brazil',
    'ru-ru': 'Ð‘Ñ€Ð°Ð·Ð¸Ð»Ð¸Ñ',
    'en-us': 'Brazil',
    id: 24,
    'zh-cn': 'å·´è¥¿',
    'de-de': 'Brasilien',
    'fr-fr': 'BrÃ©sil',
    country_code: 'BRA',
    'es-es': 'Brasil',
    'pt-br': 'Brasil'
  }, {
    'en-gb': 'British Indian Ocean Territory',
    official_en_name: 'British Indian Ocean Territory',
    cid: '26',
    native_names: 'British Indian Ocean Territory',
    'ru-ru': 'Ð‘Ñ€Ð¸Ñ‚Ð°Ð½ÑÐºÐ°Ñ Ñ‚ÐµÑ€Ñ€Ð¸Ñ‚Ð¾Ñ€Ð¸Ñ Ð² Ð˜Ð½Ð´Ð¸Ð¹ÑÐºÐ¾Ð¼ Ð¾ÐºÐµÐ°Ð½Ðµ',
    'en-us': 'British Indian Ocean Territory',
    id: 25,
    'zh-cn': 'è‹±å±žå°åº¦æ´‹é¢†åœ°',
    'de-de': 'Britisches Territorium im Indischen Ozean',
    'fr-fr': 'Territoire britannique de l`ocÃ©an Indien',
    country_code: 'IOT',
    'es-es': 'Territorio BritÃ¡nico del OcÃ©ano Ãndico',
    'pt-br': 'Território Britânico do Oceano Índico'
  }, {
    'en-gb': 'British Virgin Islands',
    official_en_name: 'Virgin Islands',
    'zh-cn': 'è‹±å±žç»´å°”äº¬ç¾¤å²›',
    native_names: 'British Virgin Islands',
    'ru-ru': 'Ð‘Ñ€Ð¸Ñ‚Ð°Ð½ÑÐºÐ¸Ðµ Ð’Ð¸Ñ€Ð³Ð¸Ð½ÑÐºÐ¸Ðµ Ð¾ÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'British Virgin Islands',
    'pt-br': 'Ilhas Virgens',
    'de-de': 'Britische Jungferninseln',
    cid: '28',
    'fr-fr': 'ÃŽles Vierges britanniques',
    country_code: 'VGB',
    'es-es': 'Islas VÃ­rgenes del Reino Unido',
    id: 26
  }, {
    'en-gb': 'Brunei',
    official_en_name: 'Nation of Brunei, Abode of Peace',
    cid: '29',
    native_names: 'Negara Brunei Darussalam',
    'ru-ru': 'Ð‘Ñ€ÑƒÐ½ÐµÐ¹',
    'en-us': 'Brunei',
    id: 27,
    'zh-cn': 'æ–‡èŽ±',
    'de-de': 'Brunei',
    'fr-fr': 'Brunei',
    country_code: 'BRN',
    'es-es': 'Brunei',
    'pt-br': 'Brunei'
  }, {
    'en-gb': 'Bulgaria',
    official_en_name: 'Republic of Bulgaria',
    cid: '30',
    native_names: 'Ð‘ÑŠÐ»Ð³Ð°Ñ€Ð¸Ñ, Bulgaria',
    'ru-ru': 'Ð‘Ð¾Ð»Ð³Ð°Ñ€Ð¸Ñ',
    'en-us': 'Bulgaria',
    id: 28,
    'zh-cn': '`Ä¿åŠ åˆ©äºš',
    'de-de': 'Bulgarien',
    'fr-fr': 'Bulgarie',
    country_code: 'BGR',
    'es-es': 'Bulgaria',
    'pt-br': 'Bulgária'
  }, {
    'en-gb': 'Burkina Faso',
    official_en_name: 'Burkina Faso',
    cid: '31',
    native_names: 'Burkina Faso',
    'ru-ru': 'Ð‘ÑƒÑ€ÐºÐ¸Ð½Ð°-Ð¤Ð°ÑÐ¾',
    'en-us': 'Burkina Faso',
    id: 29,
    'zh-cn': 'å¸ƒåŸºçº³æ³•ç´¢',
    'de-de': 'Burkina Faso',
    'fr-fr': 'Burkina Faso',
    country_code: 'BFA',
    'es-es': 'Burkina Faso',
    'pt-br': 'Burkina Faso'
  }, {
    'en-gb': 'Burundi',
    official_en_name: 'Republic of Burundi',
    cid: '32',
    native_names: 'Burundi, Uburundi',
    'ru-ru': 'Ð‘ÑƒÑ€ÑƒÐ½Ð´Ð¸',
    'en-us': 'Burundi',
    id: 30,
    'zh-cn': 'å¸ƒéš†è¿ª',
    'de-de': 'Burundi',
    'fr-fr': 'Burundi',
    country_code: 'BDI',
    'es-es': 'Burundi',
    'pt-br': 'Burundi'
  }, {
    'en-gb': 'Cambodia',
    official_en_name: 'Kingdom of Cambodia',
    cid: '33',
    native_names: 'KÃ¢mpÅ­chÃ©a, Cambodia',
    'ru-ru': 'ÐšÐ°Ð¼Ð±Ð¾Ð´Ð¶Ð°',
    'en-us': 'Cambodia',
    id: 31,
    'zh-cn': 'æŸ¬åŸ”å¯¨',
    'de-de': 'Kambodscha',
    'fr-fr': 'Cambodge',
    country_code: 'KHM',
    'es-es': 'Camboya',
    'pt-br': 'Camboja'
  }, {
    'en-gb': 'Cameroon',
    official_en_name: 'Republic of Cameroon',
    cid: '34',
    native_names: 'Cameroun, Cameroon',
    'ru-ru': 'ÐšÐ°Ð¼ÐµÑ€ÑƒÐ½',
    'en-us': 'Cameroon',
    id: 32,
    'zh-cn': 'å–€éº¦éš†',
    'de-de': 'Kamerun',
    'fr-fr': 'Cameroun',
    country_code: 'CMR',
    'es-es': 'CamerÃºn',
    'pt-br': 'Camarões'
  }, {
    'en-gb': 'Canada',
    official_en_name: 'Canada',
    cid: '35',
    native_names: 'Canada',
    'ru-ru': 'ÐšÐ°Ð½Ð°Ð´Ð°',
    'en-us': 'Canada',
    id: 33,
    'zh-cn': 'åŠ æ‹¿å¤§',
    'de-de': 'Kanada',
    'fr-fr': 'Canada',
    country_code: 'CAN',
    'es-es': 'CanadÃ¡',
    'pt-br': 'Canadá'
  }, {
    'en-gb': 'Cape Verde',
    official_en_name: 'Republic of Cabo Verde',
    cid: '36',
    native_names: 'Cabo Verde, Cape Verde',
    'ru-ru': 'ÐšÐ°Ð±Ð¾-Ð’ÐµÑ€Ð´Ðµ',
    'en-us': 'Cape Verde',
    id: 34,
    'zh-cn': '`Ä½›å¾—è§’',
    'de-de': 'Kap Verde',
    'fr-fr': 'ÃŽles du Cap-Vert',
    country_code: 'CPV',
    'es-es': 'Cabo Verde',
    'pt-br': 'Cabo Verde'
  }, {
    'en-gb': 'Cayman Islands',
    official_en_name: 'Cayman Islands',
    cid: '37',
    native_names: 'Cayman Islands',
    'ru-ru': 'ÐšÐ°Ð¹Ð¼Ð°Ð½Ð¾Ð²Ñ‹ Ð¾ÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'Cayman Islands',
    id: 35,
    'zh-cn': 'å¼€æ›¼ç¾¤å²›',
    'de-de': 'Kaimaninseln',
    'fr-fr': 'ÃŽles CaÃ¯mans',
    country_code: 'CYM',
    'es-es': 'Islas CaimÃ¡n',
    'pt-br': 'Ilhas Caimã'
  }, {
    'en-gb': 'Central African Republic',
    official_en_name: 'Central African Republic',
    cid: '38',
    native_names: 'RÃ©publique centrafricaine, Central African Republic, BÃªafrÃ®ka',
    'ru-ru': 'Ð¦ÐµÐ½Ñ‚Ñ€Ð°Ð»ÑŒÐ½Ð¾Ð°Ñ„Ñ€Ð¸ÐºÐ°Ð½ÑÐºÐ°Ñ Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ°',
    'en-us': 'Central African Republic',
    id: 36,
    'zh-cn': '`Ä¸­éžå…±å’Œå›½',
    'de-de': 'Zentralafrikanische Republik',
    'fr-fr': 'RÃ©publique centrafricaine',
    country_code: 'CAF',
    'es-es': 'RepÃºblica Centroafricana',
    'pt-br': 'República Centro-Africana'
  }, {
    'en-gb': 'Chad',
    official_en_name: 'Republic of Chad',
    cid: '39',
    native_names: 'ØªØ´Ø§Ø¯â€Ž, Chad, Tchad',
    'ru-ru': 'Ð§Ð°Ð´',
    'en-us': 'Chad',
    id: 37,
    'zh-cn': '`Ä¹å¾—',
    'de-de': 'Tschad',
    'fr-fr': 'Tchad',
    country_code: 'TCD',
    'es-es': 'Chad',
    'pt-br': 'Chade'
  }, {
    'en-gb': 'Chile',
    official_en_name: 'Republic of Chile',
    cid: '40',
    native_names: 'Chile',
    'ru-ru': 'Ð§Ð¸Ð»Ð¸',
    'en-us': 'Chile',
    id: 38,
    'zh-cn': 'æ™ºåˆ©',
    'de-de': 'Chile',
    'fr-fr': 'Chili',
    country_code: 'CHL',
    'es-es': 'Chile',
    'pt-br': 'Chile'
  }, {
    'en-gb': 'China',
    official_en_name: 'People`s Republic of China',
    cid: '41',
    native_names: '`Ä¸­å›½, China',
    'ru-ru': 'ÐšÐ¸Ñ‚Ð°Ð¹',
    'en-us': 'China',
    'pt-br': 'China',
    'de-de': 'China',
    'fr-fr': 'Chine',
    country_code: 'CHN',
    'es-es': 'China',
    id: 39
  }, {
    'en-gb': 'Colombia',
    official_en_name: 'Republic of Colombia',
    cid: '42',
    native_names: 'Colombia',
    'ru-ru': 'ÐšÐ¾Ð»ÑƒÐ¼Ð±Ð¸Ñ',
    'en-us': 'Colombia',
    id: 40,
    'zh-cn': 'å“¥ä¼¦æ¯”äºš',
    'de-de': 'Kolumbien',
    'fr-fr': 'Colombie',
    country_code: 'COL',
    'es-es': 'Colombia',
    'pt-br': 'Colômbia'
  }, {
    'en-gb': 'Comoros',
    official_en_name: 'Union of the Comoros',
    cid: '43',
    native_names: 'Ø§Ù„Ù‚Ù…Ø±â€Ž, Comoros, Comores, Komori',
    'ru-ru': 'ÐšÐ¾Ð¼Ð¾Ñ€Ñ‹',
    'en-us': 'Comoros',
    id: 41,
    'zh-cn': 'ç§‘æ‘©ç½—',
    'de-de': 'Union der Komoren',
    'fr-fr': 'Comores',
    country_code: 'COM',
    'es-es': 'Comoras',
    'pt-br': 'Comores'
  }, {
    'en-gb': 'Republic of the Congo',
    official_en_name: 'Republic of the Congo',
    cid: '44',
    native_names: 'RÃ©publique du Congo, Republic of the Congo, RepublÃ­ki ya KongÃ³, Repubilika ya Kongo',
    'ru-ru': 'Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ° ÐšÐ¾Ð½Ð³Ð¾',
    'en-us': 'Republic of the Congo',
    id: 42,
    'zh-cn': 'åˆšæžœ',
    'de-de': 'Kongo',
    'fr-fr': 'Congo',
    country_code: 'COG',
    'es-es': 'Congo',
    'pt-br': 'Congo'
  }, {
    'en-gb': 'DR Congo',
    official_en_name: 'Democratic Republic of the Congo',
    cid: '45',
    native_names: 'Jamhuri ya Kidemokrasia ya Kongo, DR Congo, Ditunga dia Kongu wa Mungalaata, RD Congo, Republiki ya KongÃ³ Demokratiki, Repubilika ya Kongo Demokratiki',
    'ru-ru': 'Ð”ÐµÐ¼Ð¾ÐºÑ€Ð°Ñ‚Ð¸Ñ‡ÐµÑÐºÐ°Ñ Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ° ÐšÐ¾Ð½Ð³Ð¾',
    'en-us': 'DR Congo',
    id: 43,
    'zh-cn': 'æ°‘ä¸»åˆšæžœ',
    'de-de': 'Kongo (Dem. Rep.)',
    'fr-fr': 'Congo (RÃ©p. dÃ©m.)',
    country_code: 'COD',
    'es-es': 'Congo (Rep. Dem.)',
    'pt-br': 'República Democrática do Congo'
  }, {
    'en-gb': 'Cook Islands',
    official_en_name: 'Cook Islands',
    cid: '46',
    native_names: 'KÅ«ki `Ä€irani, Cook Islands',
    'ru-ru': 'ÐžÑÑ‚Ñ€Ð¾Ð²Ð° ÐšÑƒÐºÐ°',
    'en-us': 'Cook Islands',
    id: 44,
    'zh-cn': 'åº“å…‹ç¾¤å²›',
    'de-de': 'Cookinseln',
    'fr-fr': 'ÃŽles Cook',
    country_code: 'COK',
    'es-es': 'Islas Cook',
    'pt-br': 'Ilhas Cook'
  }, {
    'en-gb': 'Costa Rica',
    official_en_name: 'Republic of Costa Rica',
    cid: '47',
    native_names: 'Costa Rica',
    'ru-ru': 'ÐšÐ¾ÑÑ‚Ð°-Ð Ð¸ÐºÐ°',
    'en-us': 'Costa Rica',
    id: 45,
    'zh-cn': 'å“¥æ–¯è¾¾é»ŽåŠ ',
    'de-de': 'Costa Rica',
    'fr-fr': 'Costa Rica',
    country_code: 'CRI',
    'es-es': 'Costa Rica',
    'pt-br': 'Costa Rica'
  }, {
    'en-gb': 'Ivory Coast',
    official_en_name: 'Republic of CÃ´te d`Ivoire',
    'zh-cn': 'ç§‘ç‰¹è¿ªç“¦',
    native_names: 'Côte d`Ivoire, Ivory Coast',
    'ru-ru': 'ÐšÐ¾Ñ‚-Ð´â€™Ð˜Ð²ÑƒÐ°Ñ€',
    'en-us': 'Ivory Coast',
    'pt-br': 'Costa do Marfim',
    'de-de': 'ElfenbeinkÃ¼ste',
    cid: '48',
    'fr-fr': 'Côte d`Ivoire',
    country_code: 'CIV',
    'es-es': 'Costa de Marfil',
    id: 46
  }, {
    'en-gb': 'Croatia',
    official_en_name: 'Republic of Croatia',
    cid: '49',
    native_names: 'Hrvatska, Croatia',
    'ru-ru': 'Ð¥Ð¾Ñ€Ð²Ð°Ñ‚Ð¸Ñ',
    'en-us': 'Croatia',
    id: 47,
    'zh-cn': 'å…‹ç½—åœ°äºš',
    'de-de': 'Kroatien',
    'fr-fr': 'Croatie',
    country_code: 'HRV',
    'es-es': 'Croacia',
    'pt-br': 'Croácia'
  }, {
    'en-gb': 'Cuba',
    official_en_name: 'Republic of Cuba',
    cid: '50',
    native_names: 'Cuba',
    'ru-ru': 'ÐšÑƒÐ±Ð°',
    'en-us': 'Cuba',
    id: 48,
    'zh-cn': 'å¤å·´',
    'de-de': 'Kuba',
    'fr-fr': 'Cuba',
    country_code: 'CUB',
    'es-es': 'Cuba',
    'pt-br': 'Cuba'
  }, {
    'en-gb': 'Cyprus',
    official_en_name: 'Republic of Cyprus',
    cid: '51',
    native_names: 'KÄ±brÄ±s, Cyprus, ÎšÏÏ€ÏÎ¿Ï‚',
    'ru-ru': 'ÐšÐ¸Ð¿Ñ€',
    'en-us': 'Cyprus',
    id: 49,
    'zh-cn': 'å¡žæµ¦è·¯æ–¯',
    'de-de': 'Zypern',
    'fr-fr': 'Chypre',
    country_code: 'CYP',
    'es-es': 'Chipre',
    'pt-br': 'Chipre'
  }, {
    'en-gb': 'Czechia',
    official_en_name: 'Czech Republic',
    cid: '52',
    native_names: '`ÄŒesko, Czechia',
    'ru-ru': 'Ð§ÐµÑ…Ð¸Ñ',
    'en-us': 'Czechia',
    id: 50,
    'zh-cn': 'æ·å…‹',
    'de-de': 'Tschechien',
    'fr-fr': 'TchÃ©quie',
    country_code: 'CZE',
    'es-es': 'Chequia',
    'pt-br': 'República Checa'
  }, {
    'en-gb': 'Denmark',
    official_en_name: 'Kingdom of Denmark',
    cid: '53',
    native_names: 'Danmark, Denmark',
    'ru-ru': 'Ð”Ð°Ð½Ð¸Ñ',
    'en-us': 'Denmark',
    id: 51,
    'zh-cn': '`Ä¸¹éº¦',
    'de-de': 'DÃ¤nemark',
    'fr-fr': 'Danemark',
    country_code: 'DNK',
    'es-es': 'Dinamarca',
    'pt-br': 'Dinamarca'
  }, {
    'en-gb': 'Djibouti',
    official_en_name: 'Republic of Djibouti',
    cid: '54',
    native_names: 'Ø¬ÙŠØ¨ÙˆØªÙŠâ€Ž, Djibouti',
    'ru-ru': 'Ð”Ð¶Ð¸Ð±ÑƒÑ‚Ð¸',
    'en-us': 'Djibouti',
    id: 52,
    'zh-cn': 'å‰å¸ƒæ',
    'de-de': 'Dschibuti',
    'fr-fr': 'Djibouti',
    country_code: 'DJI',
    'es-es': 'Djibouti',
    'pt-br': 'Djibouti'
  }, {
    'en-gb': 'Dominica',
    official_en_name: 'Commonwealth of Dominica',
    cid: '55',
    native_names: 'Dominica',
    'ru-ru': 'Ð”Ð¾Ð¼Ð¸Ð½Ð¸ÐºÐ°',
    'en-us': 'Dominica',
    id: 53,
    'zh-cn': 'å¤šç±³å°¼åŠ ',
    'de-de': 'Dominica',
    'fr-fr': 'Dominique',
    country_code: 'DMA',
    'es-es': 'Dominica',
    'pt-br': 'Dominica'
  }, {
    'en-gb': 'Dominican Republic',
    official_en_name: 'Dominican Republic',
    cid: '56',
    native_names: 'RepÃºblica Dominicana, Dominican Republic',
    'ru-ru': 'Ð”Ð¾Ð¼Ð¸Ð½Ð¸ÐºÐ°Ð½ÑÐºÐ°Ñ Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ°',
    'en-us': 'Dominican Republic',
    id: 54,
    'zh-cn': 'å¤šæ˜Žå°¼åŠ ',
    'de-de': 'Dominikanische Republik',
    'fr-fr': 'RÃ©publique dominicaine',
    country_code: 'DOM',
    'es-es': 'República Dominicana',
    'pt-br': 'República Dominicana'
  }, {
    'en-gb': 'Timor-Leste',
    official_en_name: 'Democratic Republic of Timor-Leste',
    'zh-cn': '`Ä¸œå¸æ±¶',
    native_names: 'TimÃ³r-Leste, Timor-Leste',
    'ru-ru': 'Ð’Ð¾ÑÑ‚Ð¾Ñ‡Ð½Ñ‹Ð¹ Ð¢Ð¸Ð¼Ð¾Ñ€',
    'en-us': 'Timor-Leste',
    'pt-br': 'Timor-Leste',
    'de-de': 'Timor-Leste',
    cid: '57',
    'fr-fr': 'Timor oriental',
    country_code: 'TLS',
    'es-es': 'Timor Oriental',
    id: 55
  }, {
    'en-gb': 'Ecuador',
    official_en_name: 'Republic of Ecuador',
    cid: '58',
    native_names: 'Ecuador',
    'ru-ru': 'Ð­ÐºÐ²Ð°Ð´Ð¾Ñ€',
    'en-us': 'Ecuador',
    id: 56,
    'zh-cn': 'åŽ„ç“œå¤šå°”',
    'de-de': 'Ecuador',
    'fr-fr': 'Ã‰quateur',
    country_code: 'ECU',
    'es-es': 'Ecuador',
    'pt-br': 'Equador'
  }, {
    'en-gb': 'Egypt',
    official_en_name: 'Arab Republic of Egypt',
    cid: '59',
    native_names: 'Ù…ØµØ±, Egypt',
    'ru-ru': 'Ð•Ð³Ð¸Ð¿ÐµÑ‚',
    'en-us': 'Egypt',
    id: 57,
    'zh-cn': 'åŸƒåŠ',
    'de-de': 'Ã„gypten',
    'fr-fr': 'Ã‰gypte',
    country_code: 'EGY',
    'es-es': 'Egipto',
    'pt-br': 'Egito'
  }, {
    'en-gb': 'El Salvador',
    official_en_name: 'Republic of El Salvador',
    cid: '60',
    native_names: 'El Salvador',
    'ru-ru': 'Ð¡Ð°Ð»ÑŒÐ²Ð°Ð´Ð¾Ñ€',
    'en-us': 'El Salvador',
    id: 58,
    'zh-cn': 'è¨å°”ç“¦å¤š',
    'de-de': 'El Salvador',
    'fr-fr': 'salvador',
    country_code: 'sLV',
    'es-es': 'El Salvador',
    'pt-br': 'El Salvador'
  }, {
    'en-gb': 'Equatorial Guinea',
    official_en_name: 'Republic of Equatorial Guinea',
    cid: '61',
    native_names: 'Guinea Ecuatorial, Equatorial Guinea, GuinÃ©e Ã©quatoriale, GuinÃ© Equatorial',
    'ru-ru': 'Ð­ÐºÐ²Ð°Ñ‚Ð¾Ñ€Ð¸Ð°Ð»ÑŒÐ½Ð°Ñ Ð“Ð²Ð¸Ð½ÐµÑ',
    'en-us': 'Equatorial Guinea',
    id: 59,
    'zh-cn': 'èµ¤é“å‡ å†…äºš',
    'de-de': 'Ã„quatorialguinea',
    'fr-fr': 'GuinÃ©e Ã©quatoriale',
    country_code: 'GNQ',
    'es-es': 'Guinea Ecuatorial',
    'pt-br': 'Guiné Equatorial'
  }, {
    'en-gb': 'Eritrea',
    official_en_name: 'state of Eritrea',
    cid: '62',
    native_names: 'Ø¥Ø±ØªØ±ÙŠØ§â€Ž, Eritrea, áŠ¤áˆ­á‰µáˆ«',
    'ru-ru': 'Ð­Ñ€Ð¸Ñ‚Ñ€ÐµÑ',
    'en-us': 'Eritrea',
    id: 60,
    'zh-cn': 'åŽ„ç«‹ç‰¹é‡Œäºš',
    'de-de': 'Eritrea',
    'fr-fr': 'Ã‰rythrÃ©e',
    country_code: 'ERI',
    'es-es': 'Eritrea',
    'pt-br': 'Eritréia'
  }, {
    'en-gb': 'Estonia',
    official_en_name: 'Republic of Estonia',
    cid: '63',
    native_names: 'Eesti, Estonia',
    'ru-ru': 'Ð­ÑÑ‚Ð¾Ð½Ð¸Ñ',
    'en-us': 'Estonia',
    id: 61,
    'zh-cn': 'çˆ±æ²™å°¼äºš',
    'de-de': 'Estland',
    'fr-fr': 'Estonie',
    country_code: 'EST',
    'es-es': 'Estonia',
    'pt-br': 'Estônia'
  }, {
    'en-gb': 'Ethiopia',
    official_en_name: 'Federal Democratic Republic of Ethiopia',
    cid: '64',
    native_names: 'áŠ¢á‰µá‹®áŒµá‹«, Ethiopia',
    'ru-ru': 'Ð­Ñ„Ð¸Ð¾Ð¿Ð¸Ñ',
    'en-us': 'Ethiopia',
    id: 62,
    'zh-cn': 'åŸƒå¡žä¿„æ¯”äºš',
    'de-de': 'Ã„thiopien',
    'fr-fr': 'Ã‰thiopie',
    country_code: 'ETH',
    'es-es': 'EtiopÃ­a',
    'pt-br': 'Etiópia'
  }, {
    'en-gb': 'Falkland Islands',
    official_en_name: 'Falkland Islands',
    'zh-cn': 'ç¦å…‹å…°ç¾¤å²›',
    native_names: 'Falkland Islands',
    'ru-ru': 'Ð¤Ð¾Ð»ÐºÐ»ÐµÐ½Ð´ÑÐºÐ¸Ðµ Ð¾ÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'Falkland Islands',
    'pt-br': 'Ilhas Malvinas',
    'de-de': 'Falklandinseln',
    cid: '65',
    'fr-fr': 'ÃŽles Malouines',
    country_code: 'FLK',
    'es-es': 'Islas Malvinas',
    id: 63
  }, {
    'en-gb': 'Faroe Islands',
    official_en_name: 'Faroe Islands',
    'zh-cn': 'æ³•ç½—ç¾¤å²›',
    native_names: 'FÃ¦rÃ¸erne, Faroe Islands, FÃ¸royar',
    'ru-ru': 'Ð¤Ð°Ñ€ÐµÑ€ÑÐºÐ¸Ðµ Ð¾ÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'Faroe Islands',
    'pt-br': 'Ilhas Faroé',
    'de-de': 'FÃ¤rÃ¶er-Inseln',
    cid: '66',
    'fr-fr': 'ÃŽles FÃ©roÃ©',
    country_code: 'FRO',
    'es-es': 'Islas Faroe',
    id: 64
  }, {
    'en-gb': 'Micronesia',
    official_en_name: 'Federated States of Micronesia',
    'zh-cn': 'å¯†å…‹ç½—å°¼è¥¿äºš',
    native_names: 'Micronesia',
    'ru-ru': 'Ð¤ÐµÐ´ÐµÑ€Ð°Ñ‚Ð¸Ð²Ð½Ñ‹Ðµ Ð¨Ñ‚Ð°Ñ‚Ñ‹ ÐœÐ¸ÐºÑ€Ð¾Ð½ÐµÐ·Ð¸Ð¸',
    'en-us': 'Micronesia',
    'pt-br': 'Micronésia',
    'de-de': 'Mikronesien',
    cid: '67',
    'fr-fr': 'MicronÃ©sie',
    country_code: 'FSM',
    'es-es': 'Micronesia',
    id: 65
  }, {
    'en-gb': 'Fiji',
    official_en_name: 'Republic of Fiji',
    'zh-cn': 'æ–æµŽ',
    native_names: 'Viti, Fiji, à¤«à¤¿à¤œà¥€',
    'ru-ru': 'Ð¤Ð¸Ð´Ð¶Ð¸',
    'en-us': 'Fiji',
    'pt-br': 'Fiji',
    'de-de': 'Fidschi',
    cid: '68',
    'fr-fr': 'Fidji',
    country_code: 'FJI',
    'es-es': 'Fiyi',
    id: 66
  }, {
    'en-gb': 'Finland',
    official_en_name: 'Republic of Finland',
    'zh-cn': 'èŠ¬å…°',
    native_names: 'Finland, Suomi',
    'ru-ru': 'Ð¤Ð¸Ð½Ð»ÑÐ½Ð´Ð¸Ñ',
    'en-us': 'Finland',
    'pt-br': 'Finlândia',
    'de-de': 'Finnland',
    cid: '69',
    'fr-fr': 'Finlande',
    country_code: 'FIN',
    'es-es': 'Finlandia',
    id: 67
  }, {
    'en-gb': 'France',
    official_en_name: 'French Republic',
    'zh-cn': 'æ³•å›½',
    native_names: 'France',
    'ru-ru': 'Ð¤Ñ€Ð°Ð½Ñ†Ð¸Ñ',
    'en-us': 'France',
    'pt-br': 'França',
    'de-de': 'Frankreich',
    cid: '70',
    'fr-fr': 'France',
    country_code: 'FRA',
    'es-es': 'Francia',
    id: 68
  }, {
    'en-gb': 'Gabon',
    official_en_name: 'Gabonese Republic',
    'zh-cn': 'åŠ è“¬',
    native_names: 'Gabon',
    'ru-ru': 'Ð“Ð°Ð±Ð¾Ð½',
    'en-us': 'Gabon',
    'pt-br': 'Gabão',
    'de-de': 'Gabun',
    cid: '71',
    'fr-fr': 'Gabon',
    country_code: 'GAB',
    'es-es': 'GabÃ³n',
    id: 69
  }, {
    'en-gb': 'Gambia',
    official_en_name: 'Republic of the Gambia',
    'zh-cn': 'å†ˆæ¯”äºš',
    native_names: 'Gambia',
    'ru-ru': 'Ð“Ð°Ð¼Ð±Ð¸Ñ',
    'en-us': 'Gambia',
    'pt-br': 'Gâmbia',
    'de-de': 'Gambia',
    cid: '72',
    'fr-fr': 'Gambie',
    country_code: 'GMB',
    'es-es': 'Gambia',
    id: 70
  }, {
    'en-gb': 'Georgia',
    official_en_name: 'Georgia',
    'zh-cn': 'æ ¼é²å‰äºš',
    native_names: 'áƒ¡áƒáƒ¥áƒáƒ áƒ—áƒ•áƒ”áƒšáƒ, Georgia',
    'ru-ru': 'Ð“Ñ€ÑƒÐ·Ð¸Ñ',
    'en-us': 'Georgia',
    'pt-br': 'Geórgia',
    'de-de': 'Georgien',
    cid: '73',
    'fr-fr': 'GÃ©orgie',
    country_code: 'GEO',
    'es-es': 'Georgia',
    id: 71
  }, {
    'en-gb': 'Germany',
    official_en_name: 'Federal Republic of Germany',
    'zh-cn': 'å¾·å›½',
    native_names: 'Deutschland, Germany',
    'ru-ru': 'Ð“ÐµÑ€Ð¼Ð°Ð½Ð¸Ñ',
    'en-us': 'Germany',
    'pt-br': 'Alemanha',
    'de-de': 'Deutschland',
    cid: '74',
    'fr-fr': 'Allemagne',
    country_code: 'DEU',
    'es-es': 'Alemania',
    id: 72
  }, {
    'en-gb': 'Ghana',
    official_en_name: 'Republic of Ghana',
    'zh-cn': 'åŠ çº³',
    native_names: 'Ghana',
    'ru-ru': 'Ð“Ð°Ð½Ð°',
    'en-us': 'Ghana',
    'pt-br': 'Gana',
    'de-de': 'Ghana',
    cid: '76',
    'fr-fr': 'Ghana',
    country_code: 'GHA',
    'es-es': 'Ghana',
    id: 73
  }, {
    'en-gb': 'Gibraltar',
    official_en_name: 'Gibraltar',
    'zh-cn': 'ç›´å¸ƒç½—é™€',
    native_names: 'Gibraltar',
    'ru-ru': 'Ð“Ð¸Ð±Ñ€Ð°Ð»Ñ‚Ð°Ñ€',
    'en-us': 'Gibraltar',
    'pt-br': 'Gibraltar',
    'de-de': 'Gibraltar',
    cid: '77',
    'fr-fr': 'Gibraltar',
    country_code: 'GIB',
    'es-es': 'Gibraltar',
    id: 74
  }, {
    'en-gb': 'Greece',
    official_en_name: 'Hellenic Republic',
    'zh-cn': 'å¸Œè…Š',
    native_names: 'Î•Î»Î»Î¬Î´Î±, Greece',
    'ru-ru': 'Ð“Ñ€ÐµÑ†Ð¸Ñ',
    'en-us': 'Greece',
    'pt-br': 'Grécia',
    'de-de': 'Griechenland',
    cid: '78',
    'fr-fr': 'GrÃ¨ce',
    country_code: 'GRC',
    'es-es': 'Grecia',
    id: 75
  }, {
    'en-gb': 'Greenland',
    official_en_name: 'Greenland',
    'zh-cn': 'æ ¼é™µå…°',
    native_names: 'Kalaallit Nunaat, Greenland',
    'ru-ru': 'Ð“Ñ€ÐµÐ½Ð»Ð°Ð½Ð´Ð¸Ñ',
    'en-us': 'Greenland',
    'pt-br': 'Groelândia',
    'de-de': 'GrÃ¶nland',
    cid: '79',
    'fr-fr': 'Groenland',
    country_code: 'GRL',
    'es-es': 'Groenlandia',
    id: 76
  }, {
    'en-gb': 'Grenada',
    official_en_name: 'Grenada',
    'zh-cn': 'æ ¼æž—çº³è¾¾',
    native_names: 'Grenada',
    'ru-ru': 'Ð“Ñ€ÐµÐ½Ð°Ð´Ð°',
    'en-us': 'Grenada',
    'pt-br': 'Granada',
    'de-de': 'Grenada',
    cid: '80',
    'fr-fr': 'Grenade',
    country_code: 'GRD',
    'es-es': 'Grenada',
    id: 77
  }, {
    'en-gb': 'Guatemala',
    official_en_name: 'Republic of Guatemala',
    'zh-cn': 'å±åœ°é©¬æ‹‰',
    native_names: 'Guatemala',
    'ru-ru': 'Ð“Ð²Ð°Ñ‚ÐµÐ¼Ð°Ð»Ð°',
    'en-us': 'Guatemala',
    'pt-br': 'Guatemala',
    'de-de': 'Guatemala',
    cid: '81',
    'fr-fr': 'Guatemala',
    country_code: 'GTM',
    'es-es': 'Guatemala',
    id: 78
  }, {
    'en-gb': 'Guernsey',
    official_en_name: 'Bailiwick of Guernsey',
    'zh-cn': 'æ ¹è¥¿å²›',
    native_names: 'Guernesey, Guernsey, DgÃ¨rnÃ©siais',
    'ru-ru': 'Ð“ÐµÑ€Ð½ÑÐ¸',
    'en-us': 'Guernsey',
    'pt-br': 'Guernsey',
    'de-de': 'Guernsey',
    cid: '82',
    'fr-fr': 'Guernesey',
    country_code: 'GGY',
    'es-es': 'Guernsey',
    id: 79
  }, {
    'en-gb': 'Guinea',
    official_en_name: 'Republic of Guinea',
    'zh-cn': 'å‡ å†…äºš',
    native_names: 'GuinÃ©e, Guinea',
    'ru-ru': 'Ð“Ð²Ð¸Ð½ÐµÑ',
    'en-us': 'Guinea',
    'pt-br': 'Guiné',
    'de-de': 'Guinea',
    cid: '83',
    'fr-fr': 'GuinÃ©e',
    country_code: 'GIN',
    'es-es': 'Guinea',
    id: 80
  }, {
    'en-gb': 'Guinea-Bissau',
    official_en_name: 'Republic of Guinea-Bissau',
    'zh-cn': 'å‡ å†…äºšæ¯”ç»',
    native_names: 'GuinÃ©-Bissau, Guinea-Bissau',
    'ru-ru': 'Ð“Ð²Ð¸Ð½ÐµÑ-Ð‘Ð¸ÑÐ°Ñƒ',
    'en-us': 'Guinea-Bissau',
    'pt-br': 'Guiné-Bissau',
    'de-de': 'Guinea-Bissau',
    cid: '84',
    'fr-fr': 'GuinÃ©e-Bissau',
    country_code: 'GNB',
    'es-es': 'Guinea-BisÃ¡u',
    id: 81
  }, {
    'en-gb': 'Guyana',
    official_en_name: 'Co-operative Republic of Guyana',
    'zh-cn': 'åœ­äºšé‚£',
    native_names: 'Guyana',
    'ru-ru': 'Ð“Ð°Ð¹Ð°Ð½Ð°',
    'en-us': 'Guyana',
    'pt-br': 'Guiana',
    'de-de': 'Guyana',
    cid: '85',
    'fr-fr': 'Guyana',
    country_code: 'GUY',
    'es-es': 'Guyana',
    id: 82
  }, {
    'en-gb': 'Haiti',
    official_en_name: 'Republic of Haiti',
    'zh-cn': 'æµ·åœ°',
    native_names: 'HaÃ¯ti, Haiti, Ayiti',
    'ru-ru': 'Ð“Ð°Ð¸Ñ‚Ð¸',
    'en-us': 'Haiti',
    'pt-br': 'Haiti',
    'de-de': 'Haiti',
    cid: '86',
    'fr-fr': 'HaÃ¯ti',
    country_code: 'HTI',
    'es-es': 'Haiti',
    id: 83
  }, {
    'en-gb': 'Honduras',
    official_en_name: 'Republic of Honduras',
    'zh-cn': 'æ´ªéƒ½æ‹‰æ–¯',
    native_names: 'Honduras',
    'ru-ru': 'Ð“Ð¾Ð½Ð´ÑƒÑ€Ð°Ñ',
    'en-us': 'Honduras',
    'pt-br': 'Honduras',
    'de-de': 'Honduras',
    cid: '87',
    'fr-fr': 'Honduras',
    country_code: 'HND',
    'es-es': 'Honduras',
    id: 84
  }, {
    'en-gb': 'Hungary',
    official_en_name: 'Hungary',
    'zh-cn': 'åŒˆç‰™åˆ©',
    native_names: 'MagyarorszÃ¡g, Hungary',
    'ru-ru': 'Ð’ÐµÐ½Ð³Ñ€Ð¸Ñ',
    'en-us': 'Hungary',
    'pt-br': 'Hungria',
    'de-de': 'Ungarn',
    cid: '88',
    'fr-fr': 'Hongrie',
    country_code: 'HUN',
    'es-es': 'HungrÃ­a',
    id: 85
  }, {
    'en-gb': 'Iceland',
    official_en_name: 'Iceland',
    'zh-cn': 'å†°å²›',
    native_names: 'Ãsland, Iceland',
    'ru-ru': 'Ð˜ÑÐ»Ð°Ð½Ð´Ð¸Ñ',
    'en-us': 'Iceland',
    'pt-br': 'Islândia',
    'de-de': 'Island',
    cid: '89',
    'fr-fr': 'Islande',
    country_code: 'ISL',
    'es-es': 'Islandia',
    id: 86
  }, {
    'en-gb': 'India',
    official_en_name: 'Republic of India',
    'zh-cn': 'å°åº¦',
    native_names: 'à®‡à®¨à¯à®¤à®¿à®¯à®¾, India, à¤­à¤¾à¤°à¤¤',
    'ru-ru': 'Ð˜Ð½Ð´Ð¸Ñ',
    'en-us': 'India',
    'pt-br': 'Índia',
    'de-de': 'Indien',
    cid: '90',
    'fr-fr': 'Inde',
    country_code: 'IND',
    'es-es': 'India',
    id: 87
  }, {
    'en-gb': 'Indonesia',
    official_en_name: 'Republic of Indonesia',
    'zh-cn': 'å°åº¦å°¼è¥¿äºš',
    native_names: 'Indonesia',
    'ru-ru': 'Ð˜Ð½Ð´Ð¾Ð½ÐµÐ·Ð¸Ñ',
    'en-us': 'Indonesia',
    'pt-br': 'Indonésia',
    'de-de': 'Indonesien',
    cid: '91',
    'fr-fr': 'IndonÃ©sie',
    country_code: 'IDN',
    'es-es': 'Indonesia',
    id: 88
  }, {
    'en-gb': 'Iran',
    official_en_name: 'Islamic Republic of Iran',
    'zh-cn': '`Ä¼Šæœ—',
    native_names: 'Ø§ÛŒØ±Ø§Ù†, Iran',
    'ru-ru': 'Ð˜Ñ€Ð°Ð½',
    'en-us': 'Iran',
    'pt-br': 'Irã',
    'de-de': 'Iran',
    cid: '92',
    'fr-fr': 'Iran',
    country_code: 'IRN',
    'es-es': 'Iran',
    id: 89
  }, {
    'en-gb': 'Iraq',
    official_en_name: 'Republic of Iraq',
    'zh-cn': '`Ä¼Šæ‹‰å…‹',
    native_names: 'Ø§Ù„Ø¹Ø±Ø§Ù‚, Iraq, Ü©Ü˜Ü¼Ü›Ü¢ÜµÜ, Ú©Û†Ù…Ø§Ø±ÛŒ',
    'ru-ru': 'Ð˜Ñ€Ð°Ðº',
    'en-us': 'Iraq',
    'pt-br': 'Iraque',
    'de-de': 'Irak',
    cid: '93',
    'fr-fr': 'Irak',
    country_code: 'IRQ',
    'es-es': 'Irak',
    id: 90
  }, {
    'en-gb': 'Ireland',
    official_en_name: 'Republic of Ireland',
    'zh-cn': 'çˆ±å°”å…°',
    native_names: 'Ã‰ire, Ireland',
    'ru-ru': 'Ð˜Ñ€Ð»Ð°Ð½Ð´Ð¸Ñ',
    'en-us': 'Ireland',
    'pt-br': 'Irlanda',
    'de-de': 'Irland',
    cid: '94',
    'fr-fr': 'Irlande',
    country_code: 'IRL',
    'es-es': 'Irlanda',
    id: 91
  }, {
    'en-gb': 'Isle of Man',
    official_en_name: 'Isle of Man',
    'zh-cn': 'é©¬æ©å²›',
    native_names: 'Mannin, Isle of Man',
    'ru-ru': 'ÐžÑÑ‚Ñ€Ð¾Ð² ÐœÑÐ½',
    'en-us': 'Isle of Man',
    'pt-br': 'Ilha de Man',
    'de-de': 'Insel Man',
    cid: '95',
    'fr-fr': 'ÃŽle de Man',
    country_code: 'IMN',
    'es-es': 'Isla de Man',
    id: 92
  }, {
    'en-gb': 'Israel',
    official_en_name: 'state of Israel',
    'zh-cn': '`Ä»¥è‰²åˆ—',
    native_names: 'Ø¥Ø³Ø±Ø§Ø¦ÙŠÙ„, Israel, ×™×©×¨××œ',
    'ru-ru': 'Ð˜Ð·Ñ€Ð°Ð¸Ð»ÑŒ',
    'en-us': 'Israel',
    'pt-br': 'Israel',
    'de-de': 'Israel',
    cid: '96',
    'fr-fr': 'IsraÃ«l',
    country_code: 'ISR',
    'es-es': 'Israel',
    id: 93
  }, {
    'en-gb': 'Italy',
    official_en_name: 'Italian Republic',
    'zh-cn': 'æ„å¤§åˆ©',
    native_names: 'Italia, Italy',
    'ru-ru': 'Ð˜Ñ‚Ð°Ð»Ð¸Ñ',
    'en-us': 'Italy',
    'pt-br': 'Itália',
    'de-de': 'Italien',
    cid: '97',
    'fr-fr': 'Italie',
    country_code: 'ITA',
    'es-es': 'Italia',
    id: 94
  }, {
    'en-gb': 'Jamaica',
    official_en_name: 'Jamaica',
    'zh-cn': 'ç‰™ä¹°åŠ ',
    native_names: 'Jamaica',
    'ru-ru': 'Ð¯Ð¼Ð°Ð¹ÐºÐ°',
    'en-us': 'Jamaica',
    'pt-br': 'Jamaica',
    'de-de': 'Jamaika',
    cid: '98',
    'fr-fr': 'JamaÃ¯que',
    country_code: 'JAM',
    'es-es': 'Jamaica',
    id: 95
  }, {
    'en-gb': 'Japan',
    official_en_name: 'Japan',
    'zh-cn': 'æ—¥æœ¬',
    native_names: 'æ—¥æœ¬, Japan',
    'ru-ru': 'Ð¯Ð¿Ð¾Ð½Ð¸Ñ',
    'en-us': 'Japan',
    'pt-br': 'Japão',
    'de-de': 'Japan',
    cid: '100',
    'fr-fr': 'Japon',
    country_code: 'JPN',
    'es-es': 'JapÃ³n',
    id: 96
  }, {
    'en-gb': 'Jersey',
    official_en_name: 'Bailiwick of Jersey',
    'zh-cn': 'æ³½è¥¿å²›',
    native_names: 'Jersey, JÃ¨rri',
    'ru-ru': 'Ð”Ð¶ÐµÑ€ÑÐ¸',
    'en-us': 'Jersey',
    'pt-br': 'Jersey',
    'de-de': 'Jersey',
    cid: '101',
    'fr-fr': 'Jersey',
    country_code: 'JEY',
    'es-es': 'Jersey',
    id: 97
  }, {
    'en-gb': 'Jordan',
    official_en_name: 'Hashemite Kingdom of Jordan',
    'zh-cn': 'çº¦æ—¦',
    native_names: 'Ø§Ù„Ø£Ø±Ø¯Ù†, Jordan',
    'ru-ru': 'Ð˜Ð¾Ñ€Ð´Ð°Ð½Ð¸Ñ',
    'en-us': 'Jordan',
    'pt-br': 'Jordânia',
    'de-de': 'Jordanien',
    cid: '102',
    'fr-fr': 'Jordanie',
    country_code: 'JOR',
    'es-es': 'Jordania',
    id: 98
  }, {
    'en-gb': 'Kazakhstan',
    official_en_name: 'Republic of Kazakhstan',
    'zh-cn': 'å“ˆè¨å…‹æ–¯å¦',
    native_names: 'ÒšÐ°Ð·Ð°Ò›ÑÑ‚Ð°Ð½, Kazakhstan, ÐšÐ°Ð·Ð°Ñ…ÑÑ‚Ð°Ð½',
    'ru-ru': 'ÐšÐ°Ð·Ð°Ñ…ÑÑ‚Ð°Ð½',
    'en-us': 'Kazakhstan',
    'pt-br': 'Cazaquistão',
    'de-de': 'Kasachstan',
    cid: '103',
    'fr-fr': 'Kazakhstan',
    country_code: 'KAZ',
    'es-es': 'KazajistÃ¡n',
    id: 99
  }, {
    'en-gb': 'Kenya',
    official_en_name: 'Republic of Kenya',
    'zh-cn': 'è‚¯å°¼äºš',
    native_names: 'Kenya',
    'ru-ru': 'ÐšÐµÐ½Ð¸Ñ',
    'en-us': 'Kenya',
    'pt-br': 'Quênia',
    'de-de': 'Kenia',
    cid: '104',
    'fr-fr': 'Kenya',
    country_code: 'KEN',
    'es-es': 'Kenia',
    id: 100
  }, {
    'en-gb': 'Kiribati',
    official_en_name: 'Independent and Sovereign Republic of Kiribati',
    'zh-cn': 'åŸºé‡Œå·´æ–¯',
    native_names: 'Kiribati',
    'ru-ru': 'ÐšÐ¸Ñ€Ð¸Ð±Ð°Ñ‚Ð¸',
    'en-us': 'Kiribati',
    'pt-br': 'Kiribati',
    'de-de': 'Kiribati',
    cid: '105',
    'fr-fr': 'Kiribati',
    country_code: 'KIR',
    'es-es': 'Kiribati',
    id: 101
  }, {
    'en-gb': 'Kosovo',
    official_en_name: 'Republic of Kosovo',
    'zh-cn': 'ç§‘ç´¢æ²ƒ',
    native_names: 'Kosova, Kosovo, ÐšÐ¾ÑÐ¾Ð²Ð¾',
    'ru-ru': 'Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ° ÐšÐ¾ÑÐ¾Ð²Ð¾',
    'en-us': 'Kosovo',
    'pt-br': 'Kosovo',
    'de-de': 'Kosovo',
    cid: '106',
    'fr-fr': 'Kosovo',
    country_code: 'UNK',
    'es-es': 'Kosovo',
    id: 102
  }, {
    'en-gb': 'Kuwait',
    official_en_name: 'state of Kuwait',
    'zh-cn': 'ç§‘å¨ç‰¹',
    native_names: 'Ø§Ù„ÙƒÙˆÙŠØª, Kuwait',
    'ru-ru': 'ÐšÑƒÐ²ÐµÐ¹Ñ‚',
    'en-us': 'Kuwait',
    'pt-br': 'Kuwait',
    'de-de': 'Kuwait',
    cid: '107',
    'fr-fr': 'KoweÃ¯t',
    country_code: 'KWT',
    'es-es': 'Kuwait',
    id: 103
  }, {
    'en-gb': 'Kyrgyzstan',
    official_en_name: 'Kyrgyz Republic',
    'zh-cn': 'å‰å°”å‰æ–¯æ–¯å¦',
    native_names: 'ÐšÑ‹Ñ€Ð³Ñ‹Ð·ÑÑ‚Ð°Ð½, Kyrgyzstan, ÐšÐ¸Ñ€Ð³Ð¸Ð·Ð¸Ñ',
    'ru-ru': 'ÐšÐ¸Ñ€Ð³Ð¸Ð·Ð¸Ñ',
    'en-us': 'Kyrgyzstan',
    'pt-br': 'Quirguistão',
    'de-de': 'Kirgisistan',
    cid: '108',
    'fr-fr': 'Kirghizistan',
    country_code: 'KGZ',
    'es-es': 'KirguizistÃ¡n',
    id: 104
  }, {
    'en-gb': 'Laos',
    official_en_name: 'Lao People`s Democratic Republic',
    'zh-cn': 'è€æŒ',
    native_names: 'àºªàº›àº›àº¥àº²àº§, Laos',
    'ru-ru': 'Ð›Ð°Ð¾Ñ',
    'en-us': 'Laos',
    'pt-br': 'Laos',
    'de-de': 'Laos',
    cid: '109',
    'fr-fr': 'Laos',
    country_code: 'LAO',
    'es-es': 'Laos',
    id: 105
  }, {
    'en-gb': 'Latvia',
    official_en_name: 'Republic of Latvia',
    'zh-cn': 'æ‹‰è„±ç»´äºš',
    native_names: 'Latvija, Latvia',
    'ru-ru': 'Ð›Ð°Ñ‚Ð²Ð¸Ñ',
    'en-us': 'Latvia',
    'pt-br': 'Letônia',
    'de-de': 'Lettland',
    cid: '110',
    'fr-fr': 'Lettonie',
    country_code: 'LVA',
    'es-es': 'Letonia',
    id: 106
  }, {
    'en-gb': 'Lebanon',
    official_en_name: 'Lebanese Republic',
    'zh-cn': 'é»Žå·´å«©',
    native_names: 'Ù„Ø¨Ù†Ø§Ù†, Lebanon, Liban',
    'ru-ru': 'Ð›Ð¸Ð²Ð°Ð½',
    'en-us': 'Lebanon',
    'pt-br': 'Líbano',
    'de-de': 'Libanon',
    cid: '111',
    'fr-fr': 'Liban',
    country_code: 'LBN',
    'es-es': 'LÃ­bano',
    id: 107
  }, {
    'en-gb': 'Lesotho',
    official_en_name: 'Kingdom of Lesotho',
    'zh-cn': 'èŽ±ç´¢æ‰˜',
    native_names: 'Lesotho',
    'ru-ru': 'Ð›ÐµÑÐ¾Ñ‚Ð¾',
    'en-us': 'Lesotho',
    'pt-br': 'Lesoto',
    'de-de': 'Lesotho',
    cid: '112',
    'fr-fr': 'Lesotho',
    country_code: 'LSO',
    'es-es': 'Lesotho',
    id: 108
  }, {
    'en-gb': 'Liberia',
    official_en_name: 'Republic of Liberia',
    'zh-cn': 'åˆ©æ¯”é‡Œäºš',
    native_names: 'Liberia',
    'ru-ru': 'Ð›Ð¸Ð±ÐµÑ€Ð¸Ñ',
    'en-us': 'Liberia',
    'pt-br': 'Libéria',
    'de-de': 'Liberia',
    cid: '113',
    'fr-fr': 'Liberia',
    country_code: 'LBR',
    'es-es': 'Liberia',
    id: 109
  }, {
    'en-gb': 'Libya',
    official_en_name: 'state of Libya',
    'zh-cn': 'åˆ©æ¯”äºš',
    native_names: 'â€Ù„ÙŠØ¨ÙŠØ§, Libya',
    'ru-ru': 'Ð›Ð¸Ð²Ð¸Ñ',
    'en-us': 'Libya',
    'pt-br': 'Lí­bia',
    'de-de': 'Libyen',
    cid: '114',
    'fr-fr': 'Libye',
    country_code: 'LBY',
    'es-es': 'Libia',
    id: 110
  }, {
    'en-gb': 'Liechtenstein',
    official_en_name: 'Principality of Liechtenstein',
    'zh-cn': 'åˆ—æ”¯æ•¦å£«ç™»',
    native_names: 'Liechtenstein',
    'ru-ru': 'Ð›Ð¸Ñ…Ñ‚ÐµÐ½ÑˆÑ‚ÐµÐ¹Ð½',
    'en-us': 'Liechtenstein',
    'pt-br': 'Liechtenstein',
    'de-de': 'Liechtenstein',
    cid: '115',
    'fr-fr': 'Liechtenstein',
    country_code: 'LIE',
    'es-es': 'Liechtenstein',
    id: 111
  }, {
    'en-gb': 'Lithuania',
    official_en_name: 'Republic of Lithuania',
    'zh-cn': 'ç«‹é™¶å®›',
    native_names: 'Lietuva, Lithuania',
    'ru-ru': 'Ð›Ð¸Ñ‚Ð²Ð°',
    'en-us': 'Lithuania',
    'pt-br': 'Lituânia',
    'de-de': 'Litauen',
    cid: '116',
    'fr-fr': 'Lituanie',
    country_code: 'LTU',
    'es-es': 'Lituania',
    id: 112
  }, {
    'en-gb': 'Luxembourg',
    official_en_name: 'Grand Duchy of Luxembourg',
    'zh-cn': 'å¢æ£®å ¡',
    native_names: 'LÃ«tzebuerg, Luxembourg, Luxemburg',
    'ru-ru': 'Ð›ÑŽÐºÑÐµÐ¼Ð±ÑƒÑ€Ð³',
    'en-us': 'Luxembourg',
    'pt-br': 'Luxemburgo',
    'de-de': 'Luxemburg',
    cid: '117',
    'fr-fr': 'Luxembourg',
    country_code: 'LUX',
    'es-es': 'Luxemburgo',
    id: 113
  }, {
    'en-gb': 'Macedonia',
    official_en_name: 'Republic of Macedonia',
    'zh-cn': 'é©¬å…¶é¡¿',
    native_names: 'ÐœÐ°ÐºÐµÐ´Ð¾Ð½Ð¸Ñ˜Ð°, Macedonia',
    'ru-ru': 'Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ° ÐœÐ°ÐºÐµÐ´Ð¾Ð½Ð¸Ñ',
    'en-us': 'Macedonia',
    'pt-br': 'Macedônia',
    'de-de': 'Mazedonien',
    cid: '118',
    'fr-fr': 'MacÃ©doine',
    country_code: 'MKD',
    'es-es': 'Macedonia',
    id: 114
  }, {
    'en-gb': 'Madagascar',
    official_en_name: 'Republic of Madagascar',
    'zh-cn': 'é©¬è¾¾åŠ æ–¯åŠ ',
    native_names: 'Madagascar, Madagasikara',
    'ru-ru': 'ÐœÐ°Ð´Ð°Ð³Ð°ÑÐºÐ°Ñ€',
    'en-us': 'Madagascar',
    'pt-br': 'Madagascar',
    'de-de': 'Madagaskar',
    cid: '119',
    'fr-fr': 'Madagascar',
    country_code: 'MDG',
    'es-es': 'Madagascar',
    id: 115
  }, {
    'en-gb': 'Malawi',
    official_en_name: 'Republic of Malawi',
    'zh-cn': 'é©¬æ‹‰ç»´',
    native_names: 'MalaÅµi, Malawi',
    'ru-ru': 'ÐœÐ°Ð»Ð°Ð²Ð¸',
    'en-us': 'Malawi',
    'pt-br': 'Malawi',
    'de-de': 'Malawi',
    cid: '120',
    'fr-fr': 'Malawi',
    country_code: 'MWI',
    'es-es': 'Malawi',
    id: 116
  }, {
    'en-gb': 'Malaysia',
    official_en_name: 'Malaysia',
    'zh-cn': 'é©¬æ¥è¥¿äºš',
    native_names: 'Ù…Ù„ÙŠØ³ÙŠØ§, Malaysia',
    'ru-ru': 'ÐœÐ°Ð»Ð°Ð¹Ð·Ð¸Ñ',
    'en-us': 'Malaysia',
    'pt-br': 'Malásia',
    'de-de': 'Malaysia',
    cid: '121',
    'fr-fr': 'Malaisie',
    country_code: 'MYS',
    'es-es': 'Malasia',
    id: 117
  }, {
    'en-gb': 'Maldives',
    official_en_name: 'Republic of the Maldives',
    'zh-cn': 'é©¬å°”ä»£å¤«',
    native_names: 'Þ‹Þ¨ÞˆÞ¬Þ€Þ¨ÞƒÞ§Þ‡Þ°Þ–Þ­ÞŽÞ¬, Maldives',
    'ru-ru': 'ÐœÐ°Ð»ÑŒÐ´Ð¸Ð²Ñ‹',
    'en-us': 'Maldives',
    'pt-br': 'Maldivas',
    'de-de': 'Malediven',
    cid: '122',
    'fr-fr': 'Maldives',
    country_code: 'MDV',
    'es-es': 'Maldivas',
    id: 118
  }, {
    'en-gb': 'Mali',
    official_en_name: 'Republic of Mali',
    'zh-cn': 'é©¬é‡Œ',
    native_names: 'Mali',
    'ru-ru': 'ÐœÐ°Ð»Ð¸',
    'en-us': 'Mali',
    'pt-br': 'Mali',
    'de-de': 'Mali',
    cid: '123',
    'fr-fr': 'Mali',
    country_code: 'MLI',
    'es-es': 'Mali',
    id: 119
  }, {
    'en-gb': 'Malta',
    official_en_name: 'Republic of Malta',
    'zh-cn': 'é©¬è€³ä»–',
    native_names: 'Malta',
    'ru-ru': 'ÐœÐ°Ð»ÑŒÑ‚Ð°',
    'en-us': 'Malta',
    'pt-br': 'Malta',
    'de-de': 'Malta',
    cid: '124',
    'fr-fr': 'Malte',
    country_code: 'MLT',
    'es-es': 'Malta',
    id: 120
  }, {
    'en-gb': 'Marshall Islands',
    official_en_name: 'Republic of the Marshall Islands',
    'zh-cn': 'é©¬ç»å°”ç¾¤å²›',
    native_names: 'MÌ§ajeÄ¼, Marshall Islands',
    'ru-ru': 'ÐœÐ°Ñ€ÑˆÐ°Ð»Ð»Ð¾Ð²Ñ‹ ÐžÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'Marshall Islands',
    'pt-br': 'Ilhas Marshall',
    'de-de': 'Marshallinseln',
    cid: '125',
    'fr-fr': 'ÃŽles Marshall',
    country_code: 'MHL',
    'es-es': 'Islas Marshall',
    id: 121
  }, {
    'en-gb': 'Mauritania',
    official_en_name: 'Islamic Republic of Mauritania',
    'zh-cn': 'æ¯›é‡Œå¡”å°¼äºš',
    native_names: 'Ù…ÙˆØ±ÙŠØªØ§Ù†ÙŠØ§, Mauritania',
    'ru-ru': 'ÐœÐ°Ð²Ñ€Ð¸Ñ‚Ð°Ð½Ð¸Ñ',
    'en-us': 'Mauritania',
    'pt-br': 'Mauritânia',
    'de-de': 'Mauretanien',
    cid: '126',
    'fr-fr': 'Mauritanie',
    country_code: 'MRT',
    'es-es': 'Mauritania',
    id: 122
  }, {
    'en-gb': 'Mauritius',
    official_en_name: 'Republic of Mauritius',
    'zh-cn': 'æ¯›é‡Œæ±‚æ–¯',
    native_names: 'Maurice, Mauritius, Moris',
    'ru-ru': 'ÐœÐ°Ð²Ñ€Ð¸ÐºÐ¸Ð¹',
    'en-us': 'Mauritius',
    'pt-br': 'Maurício',
    'de-de': 'Mauritius',
    cid: '127',
    'fr-fr': 'ÃŽle Maurice',
    country_code: 'MUS',
    'es-es': 'Mauricio',
    id: 123
  }, {
    'en-gb': 'Mexico',
    official_en_name: 'United Mexican States',
    'zh-cn': 'å¢¨è¥¿å“¥',
    native_names: 'MÃ©xico, Mexico',
    'ru-ru': 'ÐœÐµÐºÑÐ¸ÐºÐ°',
    'en-us': 'Mexico',
    'pt-br': 'México',
    'de-de': 'Mexiko',
    cid: '128',
    'fr-fr': 'Mexique',
    country_code: 'MEX',
    'es-es': 'MÃ©xico',
    id: 124
  }, {
    'en-gb': 'Moldova',
    official_en_name: 'Republic of Moldova',
    'zh-cn': 'æ‘©å°”å¤šç“¦',
    native_names: 'Moldova',
    'ru-ru': 'ÐœÐ¾Ð»Ð´Ð°Ð²Ð¸Ñ',
    'en-us': 'Moldova',
    'pt-br': 'Moldávia',
    'de-de': 'Moldawie',
    cid: '129',
    'fr-fr': 'Moldavie',
    country_code: 'MDA',
    'es-es': 'Moldavia',
    id: 125
  }, {
    'en-gb': 'Monaco',
    official_en_name: 'Principality of Monaco',
    'zh-cn': 'æ‘©çº³å“¥',
    native_names: 'Monaco',
    'ru-ru': 'ÐœÐ¾Ð½Ð°ÐºÐ¾',
    'en-us': 'Monaco',
    'pt-br': 'Mônaco',
    'de-de': 'Monaco',
    cid: '130',
    'fr-fr': 'Monaco',
    country_code: 'MCO',
    'es-es': 'MÃ³naco',
    id: 126
  }, {
    'en-gb': 'Mongolia',
    official_en_name: 'Mongolia',
    'zh-cn': 'è’™å¤',
    native_names: 'ÐœÐ¾Ð½Ð³Ð¾Ð» ÑƒÐ»Ñ, Mongolia',
    'ru-ru': 'ÐœÐ¾Ð½Ð³Ð¾Ð»Ð¸Ñ',
    'en-us': 'Mongolia',
    'pt-br': 'Mongólia',
    'de-de': 'Mongolei',
    cid: '131',
    'fr-fr': 'Mongolie',
    country_code: 'MNG',
    'es-es': 'Mongolia',
    id: 127
  }, {
    'en-gb': 'Montenegro',
    official_en_name: 'Montenegro',
    'zh-cn': 'é»‘å±±',
    native_names: 'Ð¦Ñ€Ð½Ð° Ð“Ð¾Ñ€Ð°, Montenegro',
    'ru-ru': 'Ð§ÐµÑ€Ð½Ð¾Ð³Ð¾Ñ€Ð¸Ñ',
    'en-us': 'Montenegro',
    'pt-br': 'Montenegro',
    'de-de': 'Montenegro',
    cid: '132',
    'fr-fr': 'MontÃ©nÃ©gro',
    country_code: 'MNE',
    'es-es': 'Montenegro',
    id: 128
  }, {
    'en-gb': 'Montserrat',
    official_en_name: 'Montserrat',
    'zh-cn': 'è’™ç‰¹å¡žæ‹‰ç‰¹',
    native_names: 'Montserrat',
    'ru-ru': 'ÐœÐ¾Ð½Ñ‚ÑÐµÑ€Ñ€Ð°Ñ‚',
    'en-us': 'Montserrat',
    'pt-br': 'Montserrat',
    'de-de': 'Montserrat',
    cid: '133',
    'fr-fr': 'Montserrat',
    country_code: 'MSR',
    'es-es': 'Montserrat',
    id: 129
  }, {
    'en-gb': 'Morocco',
    official_en_name: 'Kingdom of Morocco',
    'zh-cn': 'æ‘©æ´›å“¥',
    native_names: 'âµâµŽâ´°âµ–âµ”âµ‰â´±, Morocco, Ø§Ù„Ù…ØºØ±Ø¨',
    'ru-ru': 'ÐœÐ°Ñ€Ð¾ÐºÐºÐ¾',
    'en-us': 'Morocco',
    'pt-br': 'Marrocos',
    'de-de': 'Marokko',
    cid: '134',
    'fr-fr': 'Maroc',
    country_code: 'MAR',
    'es-es': 'Marruecos',
    id: 130
  }, {
    'en-gb': 'Mozambique',
    official_en_name: 'Republic of Mozambique',
    'zh-cn': 'èŽ«æ¡‘æ¯”å…‹',
    native_names: 'MoÃ§ambique, Mozambique',
    'ru-ru': 'ÐœÐ¾Ð·Ð°Ð¼Ð±Ð¸Ðº',
    'en-us': 'Mozambique',
    'pt-br': 'Moçambique',
    'de-de': 'Mosambik',
    cid: '135',
    'fr-fr': 'Mozambique',
    country_code: 'MOZ',
    'es-es': 'Mozambique',
    id: 131
  }, {
    'en-gb': 'Myanmar',
    official_en_name: 'Republic of the Union of Myanmar',
    'zh-cn': 'ç¼…ç”¸',
    native_names: 'á€™á€¼á€”á€ºá€™á€¬, Myanmar',
    'ru-ru': 'ÐœÑŒÑÐ½Ð¼Ð°',
    'en-us': 'Myanmar',
    'pt-br': 'Myanmar',
    'de-de': 'Myanmar',
    cid: '136',
    'fr-fr': 'Birmanie',
    country_code: 'MMR',
    'es-es': 'Myanmar',
    id: 132
  }, {
    'en-gb': 'Namibia',
    official_en_name: 'Republic of Namibia',
    'zh-cn': 'çº³ç±³æ¯”äºš',
    native_names: 'Namibia, NamibiÃ«',
    'ru-ru': 'ÐÐ°Ð¼Ð¸Ð±Ð¸Ñ',
    'en-us': 'Namibia',
    'pt-br': 'Namíbia',
    'de-de': 'Namibia',
    cid: '138',
    'fr-fr': 'Namibie',
    country_code: 'NAM',
    'es-es': 'Namibia',
    id: 133
  }, {
    'en-gb': 'Nauru',
    official_en_name: 'Republic of Nauru',
    'zh-cn': 'ç‘™é²',
    native_names: 'Nauru',
    'ru-ru': 'ÐÐ°ÑƒÑ€Ñƒ',
    'en-us': 'Nauru',
    'pt-br': 'Nauru',
    'de-de': 'Nauru',
    cid: '139',
    'fr-fr': 'Nauru',
    country_code: 'NRU',
    'es-es': 'Nauru',
    id: 134
  }, {
    'en-gb': 'Nepal',
    official_en_name: 'Federal Democratic Republic of Nepal',
    'zh-cn': 'å°¼æ³Šå°”',
    native_names: 'à¤¨à¥‡à¤ªà¤¾à¤², Nepal',
    'ru-ru': 'ÐÐµÐ¿Ð°Ð»',
    'en-us': 'Nepal',
    'pt-br': 'Nepal',
    'de-de': 'NÃ©pal',
    cid: '140',
    'fr-fr': 'NÃ©pal',
    country_code: 'NPL',
    'es-es': 'Nepal',
    id: 135
  }, {
    'en-gb': 'Netherlands',
    official_en_name: 'Netherlands',
    'zh-cn': 'è·å…°',
    native_names: 'Nederland, Netherlands',
    'ru-ru': 'ÐÐ¸Ð´ÐµÑ€Ð»Ð°Ð½Ð´Ñ‹',
    'en-us': 'Netherlands',
    'pt-br': 'Holanda',
    'de-de': 'Niederlande',
    cid: '141',
    'fr-fr': 'Pays-Bas',
    country_code: 'NLD',
    'es-es': 'PaÃ­ses Bajos',
    id: 136
  }, {
    'en-gb': 'New Zealand',
    official_en_name: 'New Zealand',
    'zh-cn': 'æ–°è¥¿å…°',
    native_names: 'New Zealand, Aotearoa',
    'ru-ru': 'ÐÐ¾Ð²Ð°Ñ Ð—ÐµÐ»Ð°Ð½Ð´Ð¸Ñ',
    'en-us': 'New Zealand',
    'pt-br': 'Nova Zelândia',
    'de-de': 'Neuseeland',
    cid: '142',
    'fr-fr': 'Nouvelle-ZÃ©lande',
    country_code: 'NZL',
    'es-es': 'Nueva Zelanda',
    id: 137
  }, {
    'en-gb': 'Nicaragua',
    official_en_name: 'Republic of Nicaragua',
    'zh-cn': 'å°¼åŠ æ‹‰ç“œ',
    native_names: 'Nicaragua',
    'ru-ru': 'ÐÐ¸ÐºÐ°Ñ€Ð°Ð³ÑƒÐ°',
    'en-us': 'Nicaragua',
    'pt-br': 'Nicarágua',
    'de-de': 'Nicaragua',
    cid: '143',
    'fr-fr': 'Nicaragua',
    country_code: 'NIC',
    'es-es': 'Nicaragua',
    id: 138
  }, {
    'en-gb': 'Niger',
    official_en_name: 'Republic of Niger',
    'zh-cn': 'å°¼æ—¥å°”',
    native_names: 'Niger',
    'ru-ru': 'ÐÐ¸Ð³ÐµÑ€',
    'en-us': 'Niger',
    'pt-br': 'Ní­ger',
    'de-de': 'Niger',
    cid: '144',
    'fr-fr': 'Niger',
    country_code: 'NER',
    'es-es': 'NÃ­ger',
    id: 139
  }, {
    'en-gb': 'Nigeria',
    official_en_name: 'Federal Republic of Nigeria',
    'zh-cn': 'å°¼æ—¥åˆ©äºš',
    native_names: 'Nigeria',
    'ru-ru': 'ÐÐ¸Ð³ÐµÑ€Ð¸Ñ',
    'en-us': 'Nigeria',
    'pt-br': 'Nigéria',
    'de-de': 'Nigeria',
    cid: '145',
    'fr-fr': 'NigÃ©ria',
    country_code: 'NGA',
    'es-es': 'Nigeria',
    id: 140
  }, {
    'en-gb': 'Niue',
    official_en_name: 'Niue',
    'zh-cn': 'çº½åŸƒ',
    native_names: 'NiuÄ“, Niue',
    'ru-ru': 'ÐÐ¸ÑƒÑ',
    'en-us': 'Niue',
    'pt-br': 'Niue',
    'de-de': 'Niue',
    cid: '146',
    'fr-fr': 'Niue',
    country_code: 'NIU',
    'es-es': 'Niue',
    id: 141
  }, {
    'en-gb': 'North Korea',
    official_en_name: 'Democratic People`s Republic of Korea',
    'zh-cn': 'æœé²œ',
    native_names: 'ë¶í•œ, North Korea',
    'ru-ru': 'Ð¡ÐµÐ²ÐµÑ€Ð½Ð°Ñ ÐšÐ¾Ñ€ÐµÑ',
    'en-us': 'North Korea',
    'pt-br': 'Coreia do Norte',
    'de-de': 'Nordkorea',
    cid: '147',
    'fr-fr': 'CorÃ©e du Nord',
    country_code: 'PRK',
    'es-es': 'Corea del Norte',
    id: 142
  }, {
    'en-gb': 'Norway',
    official_en_name: 'Kingdom of Norway',
    'zh-cn': 'æŒªå¨',
    native_names: 'Noreg, Norway, Norgga, Norge',
    'ru-ru': 'ÐÐ¾Ñ€Ð²ÐµÐ³Ð¸Ñ',
    'en-us': 'Norway',
    'pt-br': 'Noruega',
    'de-de': 'Norwegen',
    cid: '148',
    'fr-fr': 'NorvÃ¨ge',
    country_code: 'NOR',
    'es-es': 'Noruega',
    id: 143
  }, {
    'en-gb': 'Oman',
    official_en_name: 'sultanate of Oman',
    'zh-cn': 'é˜¿æ›¼',
    native_names: 'Ø¹Ù…Ø§Ù†, Oman',
    'ru-ru': 'ÐžÐ¼Ð°Ð½',
    'en-us': 'Oman',
    'pt-br': 'Omã',
    'de-de': 'Oman',
    cid: '149',
    'fr-fr': 'Oman',
    country_code: 'OMN',
    'es-es': 'OmÃ¡n',
    id: 144
  }, {
    'en-gb': 'Pakistan',
    official_en_name: 'Islamic Republic of Pakistan',
    'zh-cn': 'å·´åŸºæ–¯å¦',
    native_names: 'Ù¾Ø§ÙƒØ³ØªØ§Ù†, Pakistan',
    'ru-ru': 'ÐŸÐ°ÐºÐ¸ÑÑ‚Ð°Ð½',
    'en-us': 'Pakistan',
    'pt-br': 'Paquistão',
    'de-de': 'Pakistan',
    cid: '150',
    'fr-fr': 'Pakistan',
    country_code: 'PAK',
    'es-es': 'PakistÃ¡n',
    id: 145
  }, {
    'en-gb': 'Palau',
    official_en_name: 'Republic of Palau',
    'zh-cn': 'å¸•åŠ³',
    native_names: 'Belau, Palau',
    'ru-ru': 'ÐŸÐ°Ð»Ð°Ñƒ',
    'en-us': 'Palau',
    'pt-br': 'Palau',
    'de-de': 'Palau',
    cid: '151',
    'fr-fr': 'Palaos (Palau)',
    country_code: 'PLW',
    'es-es': 'Palau',
    id: 146
  }, {
    'en-gb': 'Panama',
    official_en_name: 'Republic of Panama',
    'zh-cn': 'å·´æ‹¿é©¬',
    native_names: 'PanamÃ¡, Panama',
    'ru-ru': 'ÐŸÐ°Ð½Ð°Ð¼Ð°',
    'en-us': 'Panama',
    'pt-br': 'Panamá',
    'de-de': 'Panama',
    cid: '153',
    'fr-fr': 'Panama',
    country_code: 'PAN',
    'es-es': 'PanamÃ¡',
    id: 147
  }, {
    'en-gb': 'Papua New Guinea',
    official_en_name: 'Independent State of Papua New Guinea',
    'zh-cn': 'å·´å¸ƒäºšæ–°å‡ å†…äºš',
    native_names: 'Papua Niu Gini, Papua New Guinea, Papua Niugini',
    'ru-ru': 'ÐŸÐ°Ð¿ÑƒÐ° â€” ÐÐ¾Ð²Ð°Ñ Ð“Ð²Ð¸Ð½ÐµÑ',
    'en-us': 'Papua New Guinea',
    'pt-br': 'Papua Nova Guiné',
    'de-de': 'Papua-Neuguinea',
    cid: '154',
    'fr-fr': 'Papouasie-Nouvelle-GuinÃ©e',
    country_code: 'PNG',
    'es-es': 'PapÃºa Nueva Guinea',
    id: 148
  }, {
    'en-gb': 'Paraguay',
    official_en_name: 'Republic of Paraguay',
    'zh-cn': 'å·´æ‹‰åœ­',
    native_names: 'ParaguÃ¡i, Paraguay',
    'ru-ru': 'ÐŸÐ°Ñ€Ð°Ð³Ð²Ð°Ð¹',
    'en-us': 'Paraguay',
    'pt-br': 'Paraguai',
    'de-de': 'Paraguay',
    cid: '155',
    'fr-fr': 'Paraguay',
    country_code: 'PRY',
    'es-es': 'Paraguay',
    id: 149
  }, {
    'en-gb': 'Peru',
    official_en_name: 'Republic of Peru',
    'zh-cn': 'ç§˜é²',
    native_names: 'Piruw, Peru, PerÃº',
    'ru-ru': 'ÐŸÐµÑ€Ñƒ',
    'en-us': 'Peru',
    'pt-br': 'Perú',
    'de-de': 'Peru',
    cid: '156',
    'fr-fr': 'PÃ©rou',
    country_code: 'PER',
    'es-es': 'PerÃº',
    id: 150
  }, {
    'en-gb': 'Philippines',
    official_en_name: 'Republic of the Philippines',
    'zh-cn': 'è²å¾‹å®¾',
    native_names: 'Pilipinas, Philippines',
    'ru-ru': 'Ð¤Ð¸Ð»Ð¸Ð¿Ð¿Ð¸Ð½Ñ‹',
    'en-us': 'Philippines',
    'pt-br': 'Filipinas',
    'de-de': 'Philippinen',
    cid: '157',
    'fr-fr': 'Philippines',
    country_code: 'PHL',
    'es-es': 'Filipinas',
    id: 151
  }, {
    'en-gb': 'Pitcairn Islands',
    official_en_name: 'Pitcairn Group of Islands',
    'zh-cn': 'çš®ç‰¹å‡¯æ©ç¾¤å²›',
    native_names: 'Pitcairn Islands',
    'ru-ru': 'ÐžÑÑ‚Ñ€Ð¾Ð²Ð° ÐŸÐ¸Ñ‚ÐºÑÑ€Ð½',
    'en-us': 'Pitcairn Islands',
    'pt-br': 'Ilhas Pitcairn',
    'de-de': 'Pitcairn',
    cid: '158',
    'fr-fr': 'ÃŽles Pitcairn',
    country_code: 'PCN',
    'es-es': 'Islas Pitcairn',
    id: 152
  }, {
    'en-gb': 'Poland',
    official_en_name: 'Republic of Poland',
    'zh-cn': 'æ³¢å…°',
    native_names: 'Polska, Poland',
    'ru-ru': 'ÐŸÐ¾Ð»ÑŒÑˆÐ°',
    'en-us': 'Poland',
    'pt-br': 'Polônia',
    'de-de': 'Polen',
    cid: '159',
    'fr-fr': 'Pologne',
    country_code: 'POL',
    'es-es': 'Polonia',
    id: 153
  }, {
    'en-gb': 'Portugal',
    official_en_name: 'Portuguese Republic',
    'zh-cn': 'è‘¡è„ç‰™',
    native_names: 'Portugal',
    'ru-ru': 'ÐŸÐ¾Ñ€Ñ‚ÑƒÐ³Ð°Ð»Ð¸Ñ',
    'en-us': 'Portugal',
    'pt-br': 'Portugal',
    'de-de': 'Portugal',
    cid: '160',
    'fr-fr': 'Portugal',
    country_code: 'PRT',
    'es-es': 'Portugal',
    id: 154
  }, {
    'en-gb': 'Qatar',
    official_en_name: 'state of Qatar',
    'zh-cn': 'å¡å¡”å°”',
    native_names: 'Ù‚Ø·Ø±, Qatar',
    'ru-ru': 'ÐšÐ°Ñ‚Ð°Ñ€',
    'en-us': 'Qatar',
    'pt-br': 'Catar',
    'de-de': 'Katar',
    cid: '161',
    'fr-fr': 'Qatar',
    country_code: 'QAT',
    'es-es': 'Catar',
    id: 155
  }, {
    'en-gb': 'Romania',
    official_en_name: 'Romania',
    'zh-cn': 'ç½—é©¬å°¼äºš',
    native_names: 'RomÃ¢nia, Romania',
    'ru-ru': 'Ð ÑƒÐ¼Ñ‹Ð½Ð¸Ñ',
    'en-us': 'Romania',
    'pt-br': 'Romênia',
    'de-de': 'RumÃ¤nien',
    cid: '162',
    'fr-fr': 'Roumanie',
    country_code: 'ROU',
    'es-es': 'Rumania',
    id: 156
  }, {
    'en-gb': 'Russia',
    official_en_name: 'Russian Federation',
    'zh-cn': '`Ä¿„ç½—æ–¯',
    native_names: 'Ð Ð¾ÑÑÐ¸Ñ, Russia',
    'ru-ru': 'Ð Ð¾ÑÑÐ¸Ñ',
    'en-us': 'Russia',
    'pt-br': 'Rússia',
    'de-de': 'Russland',
    cid: '163',
    'fr-fr': 'Russie',
    country_code: 'RUS',
    'es-es': 'Rusia',
    id: 157
  }, {
    'en-gb': 'Rwanda',
    official_en_name: 'Republic of Rwanda',
    'zh-cn': 'å¢æ—ºè¾¾',
    native_names: 'Rwanda',
    'ru-ru': 'Ð ÑƒÐ°Ð½Ð´Ð°',
    'en-us': 'Rwanda',
    'pt-br': 'Ruanda',
    'de-de': 'Ruanda',
    cid: '164',
    'fr-fr': 'Rwanda',
    country_code: 'RWA',
    'es-es': 'Ruanda',
    id: 158
  }, {
    'en-gb': 'Western Sahara',
    official_en_name: 'sahrawi Arab Democratic Republic',
    'zh-cn': 'è¥¿æ’’å“ˆæ‹‰',
    native_names: 'Western Sahara, Sahara Occidental, Ø§Ù„ØµØ­Ø±Ø§Ø¡ Ø§Ù„ØºØ±Ø¨ÙŠØ©',
    'ru-ru': 'Ð—Ð°Ð¿Ð°Ð´Ð½Ð°Ñ Ð¡Ð°Ñ…Ð°Ñ€Ð°',
    'en-us': 'Western Sahara',
    'pt-br': 'saara Ocidental',
    'de-de': 'Westsahara',
    cid: '165',
    'fr-fr': 'sahara Occidental',
    country_code: 'ESH',
    'es-es': 'sahara Occidental',
    id: 159
  }, {
    'en-gb': 'saint Kitts and Nevis',
    official_en_name: 'Federation of Saint Christopher and Nevisa',
    'zh-cn': 'åœ£åŸºèŒ¨å’Œå°¼ç»´æ–¯',
    native_names: 'saint Kitts and Nevis',
    'ru-ru': 'Ð¡ÐµÐ½Ñ‚-ÐšÐ¸Ñ‚Ñ Ð¸ ÐÐµÐ²Ð¸Ñ',
    'en-us': 'saint Kitts and Nevis',
    'pt-br': 'São Cristóvão e Nevis',
    'de-de': 'saint Christopher und Nevis',
    cid: '167',
    'fr-fr': 'saint-Christophe-et-NiÃ©vÃ¨s',
    country_code: 'KNA',
    'es-es': 'san CristÃ³bal y Nieves',
    id: 160
  }, {
    'en-gb': 'saint Lucia',
    official_en_name: 'saint Lucia',
    'zh-cn': 'åœ£å¢è¥¿äºš',
    native_names: 'saint Lucia',
    'ru-ru': 'Ð¡ÐµÐ½Ñ‚-Ð›ÑŽÑÐ¸Ñ',
    'en-us': 'saint Lucia',
    'pt-br': 'Santa Lúcia',
    'de-de': 'saint Lucia',
    cid: '168',
    'fr-fr': 'sainte-Lucie',
    country_code: 'LCA',
    'es-es': 'santa LucÃ­a',
    id: 161
  }, {
    'en-gb': 'saint Vincent and the Grenadines',
    official_en_name: 'saint Vincent and the Grenadines',
    'zh-cn': 'åœ£æ–‡æ£®ç‰¹å’Œæ ¼æž—çº³ä¸æ–¯',
    native_names: 'saint Vincent and the Grenadines',
    'ru-ru': 'Ð¡ÐµÐ½Ñ‚-Ð’Ð¸Ð½ÑÐµÐ½Ñ‚ Ð¸ Ð“Ñ€ÐµÐ½Ð°Ð´Ð¸Ð½Ñ‹',
    'en-us': 'saint Vincent and the Grenadines',
    'pt-br': 'São Vincente e Granadinas',
    'de-de': 'saint Vincent und die Grenadinen',
    cid: '169',
    'fr-fr': 'saint-Vincent-et-les-Grenadines',
    country_code: 'VCT',
    'es-es': 'san Vicente y Granadinas',
    id: 162
  }, {
    'en-gb': 'samoa',
    official_en_name: 'Independent State of Samoa',
    'zh-cn': 'è¨æ‘©äºš',
    native_names: 'sÄmoa, Samoa',
    'ru-ru': 'Ð¡Ð°Ð¼Ð¾Ð°',
    'en-us': 'samoa',
    'pt-br': 'Samoa',
    'de-de': 'samoa',
    cid: '170',
    'fr-fr': 'samoa',
    country_code: 'WSM',
    'es-es': 'samoa',
    id: 163
  }, {
    'en-gb': 'san Marino',
    official_en_name: 'Most Serene Republic of San Marino',
    'zh-cn': 'åœ£é©¬åŠ›è¯º',
    native_names: 'san Marino',
    'ru-ru': 'Ð¡Ð°Ð½-ÐœÐ°Ñ€Ð¸Ð½Ð¾',
    'en-us': 'san Marino',
    'pt-br': 'San Marino',
    'de-de': 'san Marino',
    cid: '171',
    'fr-fr': 'saint-Marin',
    country_code: 'sMR',
    'es-es': 'san Marino',
    id: 164
  }, {
    'en-gb': 'sÃ£o TomÃ© and PrÃ­ncipe',
    official_en_name: 'Democratic Republic of SÃ£o TomÃ© and PrÃ­ncipe',
    'zh-cn': 'åœ£å¤šç¾Žå’Œæ™®æž—è¥¿æ¯”',
    native_names: 'sÃ£o TomÃ© e PrÃ­ncipe, SÃ£o TomÃ© and PrÃ­ncipe',
    'ru-ru': 'Ð¡Ð°Ð½-Ð¢Ð¾Ð¼Ðµ Ð¸ ÐŸÑ€Ð¸Ð½ÑÐ¸Ð¿Ð¸',
    'en-us': 'sÃ£o TomÃ© and PrÃ­ncipe',
    'pt-br': 'São Tomé e Prí­ncipe',
    'de-de': 'sÃ£o TomÃ© und PrÃ­ncipe',
    cid: '172',
    'fr-fr': 'sÃ£o TomÃ© et PrÃ­ncipe',
    country_code: 'sTP',
    'es-es': 'santo TomÃ© y PrÃ­ncipe',
    id: 165
  }, {
    'en-gb': 'saudi Arabia',
    official_en_name: 'Kingdom of Saudi Arabia',
    'zh-cn': 'æ²™ç‰¹é˜¿æ‹‰ä¼¯',
    native_names: 'Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ø³Ø¹ÙˆØ¯ÙŠØ©, Saudi Arabia',
    'ru-ru': 'Ð¡Ð°ÑƒÐ´Ð¾Ð²ÑÐºÐ°Ñ ÐÑ€Ð°Ð²Ð¸Ñ',
    'en-us': 'saudi Arabia',
    'pt-br': 'Arábia Saudita',
    'de-de': 'saudi-Arabien',
    cid: '173',
    'fr-fr': 'Arabie Saoudite',
    country_code: 'sAU',
    'es-es': 'Arabia SaudÃ­',
    id: 166
  }, {
    'en-gb': 'senegal',
    official_en_name: 'Republic of Senegal',
    'zh-cn': 'å¡žå†…åŠ å°”',
    native_names: 'sÃ©nÃ©gal, Senegal',
    'ru-ru': 'Ð¡ÐµÐ½ÐµÐ³Ð°Ð»',
    'en-us': 'senegal',
    'pt-br': 'Senegal',
    'de-de': 'senegal',
    cid: '174',
    'fr-fr': 'sÃ©nÃ©gal',
    country_code: 'sEN',
    'es-es': 'senegal',
    id: 167
  }, {
    'en-gb': 'serbia',
    official_en_name: 'Republic of Serbia',
    'zh-cn': 'å¡žå°”ç»´äºš',
    native_names: 'Ð¡Ñ€Ð±Ð¸Ñ˜Ð°, Serbia',
    'ru-ru': 'Ð¡ÐµÑ€Ð±Ð¸Ñ',
    'en-us': 'serbia',
    'pt-br': 'Sérvia',
    'de-de': 'serbien',
    cid: '175',
    'fr-fr': 'serbie',
    country_code: 'sRB',
    'es-es': 'serbia',
    id: 168
  }, {
    'en-gb': 'seychelles',
    official_en_name: 'Republic of Seychelles',
    'zh-cn': 'å¡žèˆŒå°”',
    native_names: 'sesel, Seychelles',
    'ru-ru': 'Ð¡ÐµÐ¹ÑˆÐµÐ»ÑŒÑÐºÐ¸Ðµ ÐžÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'seychelles',
    'pt-br': 'Seicheles',
    'de-de': 'seychellen',
    cid: '176',
    'fr-fr': 'seychelles',
    country_code: 'sYC',
    'es-es': 'seychelles',
    id: 169
  }, {
    'en-gb': 'sierra Leone',
    official_en_name: 'Republic of Sierra Leone',
    'zh-cn': 'å¡žæ‹‰åˆ©æ˜‚',
    native_names: 'sierra Leone',
    'ru-ru': 'Ð¡ÑŒÐµÑ€Ñ€Ð°-Ð›ÐµÐ¾Ð½Ðµ',
    'en-us': 'sierra Leone',
    'pt-br': 'serra Leoa',
    'de-de': 'sierra Leone',
    cid: '177',
    'fr-fr': 'sierra Leone',
    country_code: 'sLE',
    'es-es': 'sierra Leone',
    id: 170
  }, {
    'en-gb': 'singapore',
    official_en_name: 'Republic of Singapore',
    cid: '178',
    native_names: 'à®šà®¿à®™à¯à®•à®ªà¯à®ªà¯‚à®°à¯, Singapore, Singapura, æ–°åŠ å¡',
    'ru-ru': 'Ð¡Ð¸Ð½Ð³Ð°Ð¿ÑƒÑ€',
    'en-us': 'singapore',
    'pt-br': 'singapura',
    'de-de': 'singapur',
    'fr-fr': 'singapour',
    country_code: 'sGP',
    'es-es': 'singapur',
    id: 171
  }, {
    'en-gb': 'slovakia',
    official_en_name: 'slovak Republic',
    'zh-cn': 'æ–¯æ´›ä¼å…‹',
    native_names: 'slovensko, Slovakia',
    'ru-ru': 'Ð¡Ð»Ð¾Ð²Ð°ÐºÐ¸Ñ',
    'en-us': 'slovakia',
    'pt-br': 'Eslováquia',
    'de-de': 'slowakei',
    cid: '179',
    'fr-fr': 'slovaquie',
    country_code: 'sVK',
    'es-es': 'RepÃºblica Eslovaca',
    id: 172
  }, {
    'en-gb': 'slovenia',
    official_en_name: 'Republic of Slovenia',
    'zh-cn': 'æ–¯æ´›æ–‡å°¼äºš',
    native_names: 'slovenija, Slovenia',
    'ru-ru': 'Ð¡Ð»Ð¾Ð²ÐµÐ½Ð¸Ñ',
    'en-us': 'slovenia',
    'pt-br': 'Eslovênia',
    'de-de': 'slowenien',
    cid: '180',
    'fr-fr': 'slovÃ©nie',
    country_code: 'sVN',
    'es-es': 'Eslovenia',
    id: 173
  }, {
    'en-gb': 'solomon Islands',
    official_en_name: 'solomon Islands',
    'zh-cn': 'æ‰€ç½—é—¨ç¾¤å²›',
    native_names: 'solomon Islands',
    'ru-ru': 'Ð¡Ð¾Ð»Ð¾Ð¼Ð¾Ð½Ð¾Ð²Ñ‹ ÐžÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'solomon Islands',
    'pt-br': 'Ilhas Salomão',
    'de-de': 'salomonen',
    cid: '181',
    'fr-fr': 'ÃŽles Salomon',
    country_code: 'sLB',
    'es-es': 'Islas SalomÃ³n',
    id: 174
  }, {
    'en-gb': 'somalia',
    official_en_name: 'Federal Republic of Somalia',
    'zh-cn': 'ç´¢é©¬é‡Œ',
    native_names: 'Ø§Ù„ØµÙˆÙ…Ø§Ù„â€Žâ€Ž, Somalia, Soomaaliya',
    'ru-ru': 'Ð¡Ð¾Ð¼Ð°Ð»Ð¸',
    'en-us': 'somalia',
    'pt-br': 'somália',
    'de-de': 'somalia',
    cid: '182',
    'fr-fr': 'somalie',
    country_code: 'sOM',
    'es-es': 'somalia',
    id: 175
  }, {
    'en-gb': 'south Africa',
    official_en_name: 'Republic of South Africa',
    'zh-cn': 'å—éž',
    native_names: 'Aforika Borwa, South Africa, Afrika Dzonga, Ningizimu Afrika, Afrika-Borwa, Mzantsi Afrika, Afrika Borwa, Sewula Afrika, Afurika Tshipembe',
    'ru-ru': 'Ð®Ð¶Ð½Ð¾-ÐÑ„Ñ€Ð¸ÐºÐ°Ð½ÑÐºÐ°Ñ Ð ÐµÑÐ¿ÑƒÐ±Ð»Ð¸ÐºÐ°',
    'en-us': 'south Africa',
    'pt-br': 'África do Sul',
    'de-de': 'Republik SÃ¼dafrika',
    cid: '183',
    'fr-fr': 'Afrique du Sud',
    country_code: 'ZAF',
    'es-es': 'RepÃºblica de SudÃ¡frica',
    id: 176
  }, {
    'en-gb': 'south Georgia',
    official_en_name: 'south Georgia and the South Sandwich Islands',
    'zh-cn': 'å—ä¹”æ²»äºš',
    native_names: 'south Georgia',
    'ru-ru': 'Ð®Ð¶Ð½Ð°Ñ Ð“ÐµÐ¾Ñ€Ð³Ð¸Ñ Ð¸ Ð®Ð¶Ð½Ñ‹Ðµ Ð¡Ð°Ð½Ð´Ð²Ð¸Ñ‡ÐµÐ²Ñ‹ Ð¾ÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'south Georgia',
    'pt-br': 'Ilhas Geórgia do Sul e Sandwich do Sul',
    'de-de': 'sÃ¼dgeorgien und die SÃ¼dlichen Sandwichinseln',
    cid: '184',
    'fr-fr': 'GÃ©orgie du Sud-et-les ÃŽles Sandwich du Sud',
    country_code: 'sGS',
    'es-es': 'Islas Georgias del Sur y Sandwich del Sur',
    id: 177
  }, {
    'en-gb': 'south Korea',
    official_en_name: 'Republic of Korea',
    'zh-cn': 'éŸ©å›½',
    native_names: 'ëŒ€í•œë¯¼êµ­, South Korea',
    'ru-ru': 'Ð®Ð¶Ð½Ð°Ñ ÐšÐ¾Ñ€ÐµÑ',
    'en-us': 'south Korea',
    'pt-br': 'Coreia do Sul',
    'de-de': 'sÃ¼dkorea',
    cid: '185',
    'fr-fr': 'CorÃ©e du Sud',
    country_code: 'KOR',
    'es-es': 'Corea del Sur',
    id: 178
  }, {
    'en-gb': 'south Sudan',
    official_en_name: 'Republic of South Sudan',
    'zh-cn': 'å—è‹ä¸¹',
    native_names: 'south Sudan',
    'ru-ru': 'Ð®Ð¶Ð½Ñ‹Ð¹ Ð¡ÑƒÐ´Ð°Ð½',
    'en-us': 'south Sudan',
    'pt-br': 'sudão do Sul',
    'de-de': 'sÃ¼dsudan',
    cid: '186',
    'fr-fr': 'soudan du Sud',
    country_code: 'sSD',
    'es-es': 'sudÃ¡n del Sur',
    id: 179
  }, {
    'en-gb': 'spain',
    official_en_name: 'Kingdom of Spain',
    'zh-cn': 'è¥¿ç­ç‰™',
    native_names: 'EspaÃ±a, Spain',
    'ru-ru': 'Ð˜ÑÐ¿Ð°Ð½Ð¸Ñ',
    'en-us': 'spain',
    'pt-br': 'Espanha',
    'de-de': 'spanien',
    cid: '187',
    'fr-fr': 'Espagne',
    country_code: 'ESP',
    'es-es': 'EspaÃ±a',
    id: 180
  }, {
    'en-gb': 'sri Lanka',
    official_en_name: 'Democratic Socialist Republic of Sri Lanka',
    'zh-cn': 'æ–¯é‡Œå…°å¡',
    native_names: 'à®‡à®²à®™à¯à®•à¯ˆ, Sri Lanka, à·à·Šâ€à¶»à·“ à¶½à¶‚à¶šà·à·€',
    'ru-ru': 'Ð¨Ñ€Ð¸-Ð›Ð°Ð½ÐºÐ°',
    'en-us': 'sri Lanka',
    'pt-br': 'Siri Lanka',
    'de-de': 'sri Lanka',
    cid: '188',
    'fr-fr': 'sri Lanka',
    country_code: 'LKA',
    'es-es': 'sri Lanka',
    id: 181
  }, {
    'en-gb': 'sudan',
    official_en_name: 'Republic of the Sudan',
    'zh-cn': 'è‹ä¸¹',
    native_names: 'Ø§Ù„Ø³ÙˆØ¯Ø§Ù†, Sudan',
    'ru-ru': 'Ð¡ÑƒÐ´Ð°Ð½',
    'en-us': 'sudan',
    'pt-br': 'sudão',
    'de-de': 'sudan',
    cid: '189',
    'fr-fr': 'soudan',
    country_code: 'sDN',
    'es-es': 'sudÃ¡n',
    id: 182
  }, {
    'en-gb': 'suriname',
    official_en_name: 'Republic of Suriname',
    'zh-cn': 'è‹é‡Œå—',
    native_names: 'suriname',
    'ru-ru': 'Ð¡ÑƒÑ€Ð¸Ð½Ð°Ð¼',
    'en-us': 'suriname',
    'pt-br': 'suriname',
    'de-de': 'suriname',
    cid: '190',
    'fr-fr': 'surinam',
    country_code: 'sUR',
    'es-es': 'surinam',
    id: 183
  }, {
    'en-gb': 'swaziland',
    official_en_name: 'Kingdom of Swaziland',
    'zh-cn': 'æ–¯å¨å£«å…°',
    native_names: 'swaziland',
    'ru-ru': 'Ð¡Ð²Ð°Ð·Ð¸Ð»ÐµÐ½Ð´',
    'en-us': 'swaziland',
    'pt-br': 'suazilãndia',
    'de-de': 'swasiland',
    cid: '191',
    'fr-fr': 'swaziland',
    country_code: 'sWZ',
    'es-es': 'suazilandia',
    id: 184
  }, {
    'en-gb': 'sweden',
    official_en_name: 'Kingdom of Sweden',
    'zh-cn': 'ç‘žå…¸',
    native_names: 'sverige, Sweden',
    'ru-ru': 'Ð¨Ð²ÐµÑ†Ð¸Ñ',
    'en-us': 'sweden',
    'pt-br': 'suécia',
    'de-de': 'schweden',
    cid: '192',
    'fr-fr': 'suÃ¨de',
    country_code: 'sWE',
    'es-es': 'suecia',
    id: 185
  }, {
    'en-gb': 'switzerland',
    official_en_name: 'swiss Confederation',
    'zh-cn': 'ç‘žå£«',
    native_names: 'svizra, Switzerland, Suisse, Schweiz, Svizzera',
    'ru-ru': 'Ð¨Ð²ÐµÐ¹Ñ†Ð°Ñ€Ð¸Ñ',
    'en-us': 'switzerland',
    'pt-br': 'suíça',
    'de-de': 'schweiz',
    cid: '193',
    'fr-fr': 'suisse',
    country_code: 'CHE',
    'es-es': 'suiza',
    id: 186
  }, {
    'en-gb': 'syria',
    official_en_name: 'syrian Arab Republic',
    'zh-cn': 'å™åˆ©äºš',
    native_names: 'Ø³ÙˆØ±ÙŠØ§, Syria',
    'ru-ru': 'Ð¡Ð¸Ñ€Ð¸Ñ',
    'en-us': 'syria',
    'pt-br': 'síria',
    'de-de': 'syrien',
    cid: '194',
    'fr-fr': 'syrie',
    country_code: 'sYR',
    'es-es': 'siria',
    id: 187
  }, {
    'en-gb': 'Taiwan',
    official_en_name: 'Republic of China (Taiwan)',
    cid: '195',
    native_names: 'å°ç£, Taiwan',
    'ru-ru': 'Ð¢Ð°Ð¹Ð²Ð°Ð½ÑŒ',
    'en-us': 'Taiwan',
    'pt-br': 'Taiwan',
    'de-de': 'Taiwan',
    'fr-fr': 'TaÃ¯wan',
    country_code: 'TWN',
    'es-es': 'TaiwÃ¡n',
    id: 188
  }, {
    'en-gb': 'Tajikistan',
    official_en_name: 'Republic of Tajikistan',
    'zh-cn': 'å¡”å‰å…‹æ–¯å¦',
    native_names: 'Ð¢Ð°Ð´Ð¶Ð¸ÐºÐ¸ÑÑ‚Ð°Ð½, Tajikistan, Ð¢Ð¾Ò·Ð¸ÐºÐ¸ÑÑ‚Ð¾Ð½',
    'ru-ru': 'Ð¢Ð°Ð´Ð¶Ð¸ÐºÐ¸ÑÑ‚Ð°Ð½',
    'en-us': 'Tajikistan',
    'pt-br': 'Tajiquistão',
    'de-de': 'Tadschikistan',
    cid: '196',
    'fr-fr': 'Tadjikistan',
    country_code: 'TJK',
    'es-es': 'TayikistÃ¡n',
    id: 189
  }, {
    'en-gb': 'Tanzania',
    official_en_name: 'United Republic of Tanzania',
    'zh-cn': 'å¦æ¡‘å°¼äºš',
    native_names: 'Tanzania',
    'ru-ru': 'Ð¢Ð°Ð½Ð·Ð°Ð½Ð¸Ñ',
    'en-us': 'Tanzania',
    'pt-br': 'Tanzânia',
    'de-de': 'Tansania',
    cid: '197',
    'fr-fr': 'Tanzanie',
    country_code: 'TZA',
    'es-es': 'Tanzania',
    id: 190
  }, {
    'en-gb': 'Thailand',
    official_en_name: 'Kingdom of Thailand',
    'zh-cn': 'æ³°å›½',
    native_names: 'à¸›à¸£à¸°à¹€à¸—à¸¨à¹„à¸—à¸¢, Thailand',
    'ru-ru': 'Ð¢Ð°Ð¸Ð»Ð°Ð½Ð´',
    'en-us': 'Thailand',
    'pt-br': 'Tailândia',
    'de-de': 'Thailand',
    cid: '198',
    'fr-fr': 'ThaÃ¯lande',
    country_code: 'THA',
    'es-es': 'Tailandia',
    id: 191
  }, {
    'en-gb': 'Bahamas',
    official_en_name: 'Commonwealth of the Bahamas',
    cid: '199',
    native_names: 'Bahamas',
    'ru-ru': 'Ð‘Ð°Ð³Ð°Ð¼ÑÐºÐ¸Ðµ ÐžÑÑ‚Ñ€Ð¾Ð²Ð°',
    'en-us': 'Bahamas',
    id: 192,
    'zh-cn': 'å·´å“ˆé©¬',
    'de-de': 'Bahamas',
    'fr-fr': 'Bahamas',
    country_code: 'BHS',
    'es-es': 'Bahamas',
    'pt-br': 'Bahamas'
  }, {
    'en-gb': 'Togo',
    official_en_name: 'Togolese Republic',
    'zh-cn': 'å¤šå“¥',
    native_names: 'Togo',
    'ru-ru': 'Ð¢Ð¾Ð³Ð¾',
    'en-us': 'Togo',
    'pt-br': 'Togo',
    'de-de': 'Togo',
    cid: '201',
    'fr-fr': 'Togo',
    country_code: 'TGO',
    'es-es': 'Togo',
    id: 193
  }, {
    'en-gb': 'Tokelau',
    official_en_name: 'Tokelau',
    'zh-cn': 'æ‰˜å…‹åŠ³',
    native_names: 'Tokelau',
    'ru-ru': 'Ð¢Ð¾ÐºÐµÐ»Ð°Ñƒ',
    'en-us': 'Tokelau',
    'pt-br': 'Tokelau',
    'de-de': 'Tokelau',
    cid: '202',
    'fr-fr': 'Tokelau',
    country_code: 'TKL',
    'es-es': 'Islas Tokelau',
    id: 194
  }, {
    'en-gb': 'Tonga',
    official_en_name: 'Kingdom of Tonga',
    'zh-cn': 'æ±¤åŠ ',
    native_names: 'Tonga',
    'ru-ru': 'Ð¢Ð¾Ð½Ð³Ð°',
    'en-us': 'Tonga',
    'pt-br': 'Tonga',
    'de-de': 'Tonga',
    cid: '203',
    'fr-fr': 'Tonga',
    country_code: 'TON',
    'es-es': 'Tonga',
    id: 195
  }, {
    'en-gb': 'Trinidad and Tobago',
    official_en_name: 'Republic of Trinidad and Tobago',
    'zh-cn': 'ç‰¹ç«‹å°¼è¾¾å’Œå¤šå·´å“¥',
    native_names: 'Trinidad and Tobago',
    'ru-ru': 'Ð¢Ñ€Ð¸Ð½Ð¸Ð´Ð°Ð´ Ð¸ Ð¢Ð¾Ð±Ð°Ð³Ð¾',
    'en-us': 'Trinidad and Tobago',
    'pt-br': 'Trinidade e Tobago',
    'de-de': 'Trinidad und Tobago',
    cid: '204',
    'fr-fr': 'TrinitÃ©-et-Tobago',
    country_code: 'TTO',
    'es-es': 'Trinidad y Tobago',
    id: 196
  }, {
    'en-gb': 'Tunisia',
    official_en_name: 'Tunisian Republic',
    'zh-cn': 'çªå°¼æ–¯',
    native_names: 'ØªÙˆÙ†Ø³, Tunisia',
    'ru-ru': 'Ð¢ÑƒÐ½Ð¸Ñ',
    'en-us': 'Tunisia',
    'pt-br': 'Tuní­sia',
    'de-de': 'Tunesien',
    cid: '205',
    'fr-fr': 'Tunisie',
    country_code: 'TUN',
    'es-es': 'TÃºnez',
    id: 197
  }, {
    'en-gb': 'Turkey',
    official_en_name: 'Republic of Turkey',
    'zh-cn': 'åœŸè€³å…¶',
    native_names: 'TÃ¼rkiye, Turkey',
    'ru-ru': 'Ð¢ÑƒÑ€Ñ†Ð¸Ñ',
    'en-us': 'Turkey',
    'pt-br': 'Turquia',
    'de-de': 'TÃ¼rkei',
    cid: '206',
    'fr-fr': 'Turquie',
    country_code: 'TUR',
    'es-es': 'TurquÃ­a',
    id: 198
  }, {
    'en-gb': 'Turkmenistan',
    official_en_name: 'Turkmenistan',
    'zh-cn': 'åœŸåº“æ›¼æ–¯å¦',
    native_names: 'Ð¢ÑƒÑ€ÐºÐ¼ÐµÐ½Ð¸Ñ, Turkmenistan, TÃ¼rkmenistan',
    'ru-ru': 'Ð¢ÑƒÑ€ÐºÐ¼ÐµÐ½Ð¸Ñ',
    'en-us': 'Turkmenistan',
    'pt-br': 'Turcomenistão',
    'de-de': 'Turkmenistan',
    cid: '207',
    'fr-fr': 'TurkmÃ©nistan',
    country_code: 'TKM',
    'es-es': 'TurkmenistÃ¡n',
    id: 199
  }, {
    'en-gb': 'Turks and Caicos Islands',
    official_en_name: 'Turks and Caicos Islands',
    'zh-cn': 'ç‰¹å…‹æ–¯å’Œå‡¯ç§‘æ–¯ç¾¤å²›',
    native_names: 'Turks and Caicos Islands',
    'ru-ru': 'Ð¢ÐµÑ€ÐºÑ Ð¸ ÐšÐ°Ð¹ÐºÐ¾Ñ',
    'en-us': 'Turks and Caicos Islands',
    'pt-br': 'Ilhas Turks e Caicos',
    'de-de': 'Turks-und Caicosinseln',
    cid: '208',
    'fr-fr': 'ÃŽles Turques-et-CaÃ¯ques',
    country_code: 'TCA',
    'es-es': 'Islas Turks y Caicos',
    id: 200
  }, {
    'en-gb': 'Tuvalu',
    official_en_name: 'Tuvalu',
    'zh-cn': 'å›¾ç“¦å¢',
    native_names: 'Tuvalu',
    'ru-ru': 'Ð¢ÑƒÐ²Ð°Ð»Ñƒ',
    'en-us': 'Tuvalu',
    'pt-br': 'Tuvalu',
    'de-de': 'Tuvalu',
    cid: '209',
    'fr-fr': 'Tuvalu',
    country_code: 'TUV',
    'es-es': 'Tuvalu',
    id: 201
  }, {
    'en-gb': 'Uganda',
    official_en_name: 'Republic of Uganda',
    'zh-cn': '`Ä¹Œå¹²è¾¾',
    native_names: 'Uganda',
    'ru-ru': 'Ð£Ð³Ð°Ð½Ð´Ð°',
    'en-us': 'Uganda',
    'pt-br': 'Uganda',
    'de-de': 'Uganda',
    cid: '210',
    'fr-fr': 'Ouganda',
    country_code: 'UGA',
    'es-es': 'Uganda',
    id: 202
  }, {
    'en-gb': 'Ukraine',
    official_en_name: 'Ukraine',
    'zh-cn': '`Ä¹Œå…‹å…°',
    native_names: 'Ð£ÐºÑ€Ð°Ñ—Ð½Ð°, Ukraine',
    'ru-ru': 'Ð£ÐºÑ€Ð°Ð¸Ð½Ð°',
    'en-us': 'Ukraine',
    'pt-br': 'Ucrânia',
    'de-de': 'Ukraine',
    cid: '211',
    'fr-fr': 'Ukraine',
    country_code: 'UKR',
    'es-es': 'Ucrania',
    id: 203
  }, {
    'en-gb': 'United Arab Emirates',
    official_en_name: 'United Arab Emirates',
    'zh-cn': 'é˜¿æ‹‰ä¼¯è”åˆé…‹é•¿å›½',
    native_names: 'Ø¯ÙˆÙ„Ø© Ø§Ù„Ø¥Ù…Ø§Ø±Ø§Øª Ø§Ù„Ø¹Ø±Ø¨ÙŠØ© Ø§Ù„Ù…ØªØ­Ø¯Ø©, United Arab Emirates',
    'ru-ru': 'ÐžÐ±ÑŠÐµÐ´Ð¸Ð½Ñ‘Ð½Ð½Ñ‹Ðµ ÐÑ€Ð°Ð±ÑÐºÐ¸Ðµ Ð­Ð¼Ð¸Ñ€Ð°Ñ‚Ñ‹',
    'en-us': 'United Arab Emirates',
    'pt-br': 'Emirados Árabes Unidos',
    'de-de': 'Vereinigte Arabische Emirate',
    cid: '212',
    'fr-fr': 'Ã‰mirats arabes unis',
    country_code: 'ARE',
    'es-es': 'Emiratos Ãrabes Unidos',
    id: 204
  }, {
    'en-gb': 'United Kingdom',
    official_en_name: 'United Kingdom of Great Britain and Northern Ireland',
    'zh-cn': 'è‹±å›½',
    native_names: 'United Kingdom',
    'ru-ru': 'Ð’ÐµÐ»Ð¸ÐºÐ¾Ð±Ñ€Ð¸Ñ‚Ð°Ð½Ð¸Ñ',
    'en-us': 'United Kingdom',
    'pt-br': 'Reino Unido',
    'de-de': 'Vereinigtes KÃ¶nigreich',
    cid: '213',
    'fr-fr': 'Royaume-Uni',
    country_code: 'GBR',
    'es-es': 'Reino Unido',
    id: 205
  }, {
    'en-gb': 'United States',
    official_en_name: 'United States of America',
    'zh-cn': 'ç¾Žå›½',
    native_names: 'United States',
    'ru-ru': 'Ð¡Ð¾ÐµÐ´Ð¸Ð½Ñ‘Ð½Ð½Ñ‹Ðµ Ð¨Ñ‚Ð°Ñ‚Ñ‹ ÐÐ¼ÐµÑ€Ð¸ÐºÐ¸',
    'en-us': 'United States',
    'pt-br': 'Estados Unidos',
    'de-de': 'Vereinigte Staaten von Amerika',
    cid: '214',
    'fr-fr': 'Ã‰tats-Unis',
    country_code: 'USA',
    'es-es': 'Estados Unidos',
    id: 206
  }, {
    'en-gb': 'Uruguay',
    official_en_name: 'Oriental Republic of Uruguay',
    'zh-cn': '`Ä¹Œæ‹‰åœ­',
    native_names: 'Uruguay',
    'ru-ru': 'Ð£Ñ€ÑƒÐ³Ð²Ð°Ð¹',
    'en-us': 'Uruguay',
    'pt-br': 'Uruguai',
    'de-de': 'Uruguay',
    cid: '215',
    'fr-fr': 'Uruguay',
    country_code: 'URY',
    'es-es': 'Uruguay',
    id: 207
  }, {
    'en-gb': 'Uzbekistan',
    official_en_name: 'Republic of Uzbekistan',
    'zh-cn': '`Ä¹Œå…¹åˆ«å…‹æ–¯å¦',
    native_names: 'Ð£Ð·Ð±ÐµÐºÐ¸ÑÑ‚Ð°Ð½, Uzbekistan, Oâ€˜zbekiston',
    'ru-ru': 'Ð£Ð·Ð±ÐµÐºÐ¸ÑÑ‚Ð°Ð½',
    'en-us': 'Uzbekistan',
    'pt-br': 'Uzbequistão',
    'de-de': 'Usbekistan',
    cid: '216',
    'fr-fr': 'OuzbÃ©kistan',
    country_code: 'UZB',
    'es-es': 'UzbekistÃ¡n',
    id: 208
  }, {
    'en-gb': 'Vanuatu',
    official_en_name: 'Republic of Vanuatu',
    'zh-cn': 'ç“¦åŠªé˜¿å›¾',
    native_names: 'Vanuatu',
    'ru-ru': 'Ð’Ð°Ð½ÑƒÐ°Ñ‚Ñƒ',
    'en-us': 'Vanuatu',
    'pt-br': 'Vanuatu',
    'de-de': 'Vanuatu',
    cid: '217',
    'fr-fr': 'Vanuatu',
    country_code: 'VUT',
    'es-es': 'Vanuatu',
    id: 209
  }, {
    'en-gb': 'Vatican City',
    official_en_name: 'Vatican City State',
    'zh-cn': 'æ¢µè’‚å†ˆ',
    native_names: 'VaticanÃ¦, Vatican City, Vaticano',
    'ru-ru': 'Ð’Ð°Ñ‚Ð¸ÐºÐ°Ð½',
    'en-us': 'Vatican City',
    'pt-br': 'Cidade do Vaticano',
    'de-de': 'Vatikanstadt',
    cid: '218',
    'fr-fr': 'CitÃ© du Vatican',
    country_code: 'VAT',
    'es-es': 'Ciudad del Vaticano',
    id: 210
  }, {
    'en-gb': 'Venezuela',
    official_en_name: 'Bolivarian Republic of Venezuela',
    'zh-cn': 'å§”å†…ç‘žæ‹‰',
    native_names: 'Venezuela',
    'ru-ru': 'Ð’ÐµÐ½ÐµÑÑƒÑÐ»Ð°',
    'en-us': 'Venezuela',
    'pt-br': 'Venezuela',
    'de-de': 'Venezuela',
    cid: '219',
    'fr-fr': 'Venezuela',
    country_code: 'VEN',
    'es-es': 'Venezuela',
    id: 211
  }, {
    'en-gb': 'Vietnam',
    official_en_name: 'socialist Republic of Vietnam',
    'zh-cn': 'è¶Šå—',
    native_names: 'Viá»‡t Nam, Vietnam',
    'ru-ru': 'Ð’ÑŒÐµÑ‚Ð½Ð°Ð¼',
    'en-us': 'Vietnam',
    'pt-br': 'Vietname',
    'de-de': 'Vietnam',
    cid: '220',
    'fr-fr': 'ViÃªt Nam',
    country_code: 'VNM',
    'es-es': 'Vietnam',
    id: 212
  }, {
    'en-gb': 'Yemen',
    official_en_name: 'Republic of Yemen',
    'zh-cn': '`Ä¹Ÿé—¨',
    native_names: 'Ø§Ù„ÙŠÙŽÙ…ÙŽÙ†, Yemen',
    'ru-ru': 'Ð™ÐµÐ¼ÐµÐ½',
    'en-us': 'Yemen',
    'pt-br': 'Iêmen',
    'de-de': 'Jemen',
    cid: '221',
    'fr-fr': 'YÃ©men',
    country_code: 'YEM',
    'es-es': 'Yemen',
    id: 213
  }, {
    'en-gb': 'Zambia',
    official_en_name: 'Republic of Zambia',
    'zh-cn': 'èµžæ¯”äºš',
    native_names: 'Zambia',
    'ru-ru': 'Ð—Ð°Ð¼Ð±Ð¸Ñ',
    'en-us': 'Zambia',
    'pt-br': 'Zâmbia',
    'de-de': 'sambia',
    cid: '222',
    'fr-fr': 'Zambie',
    country_code: 'ZMB',
    'es-es': 'Zambia',
    id: 214
  }, {
    'en-gb': 'Zimbabwe',
    official_en_name: 'Republic of Zimbabwe',
    'zh-cn': 'æ´¥å·´å¸ƒéŸ¦',
    native_names: 'Zimbabwe',
    'ru-ru': 'Ð—Ð¸Ð¼Ð±Ð°Ð±Ð²Ðµ',
    'en-us': 'Zimbabwe',
    'pt-br': 'Zimbabwe',
    'de-de': 'simbabwe',
    cid: '223',
    'fr-fr': 'Zimbabwe',
    country_code: 'ZWE',
    'es-es': 'Zimbabue',
    id: 215
  }
]

export default countries
